import '@tencent/thumbplayer-plugin-super-player-plugins';
import { __spreadArray, __assign as __assign$1, __awaiter, __generator, __extends, __decorate, __metadata } from 'tslib';
import * as ThumbPlayerCore from '@tencent/thumbplayer-core';
import { defaultI18nConfig, uaTool, Logger, PLAY_EVENT, commonTool, urlTool, i18nConfig, PLAY_MODE as PLAY_MODE$1, t, PLAYER_LOG_LEVEL, CODEC, KERNEL_NAME, ERROR_CODE, lsTool, KernelFactory, netTool, VIDEO_CODEC, videoTool, jsonTool, logMethodCallDecoratorCreator, performanceCostDecoratorCreator, ReferenceReport, domTool, cookieTool, mountGlobal, SET_LEVEL_MODE } from '@tencent/thumbplayer-core';
import * as ThumbPlayerH5 from '@tencent/thumbplayer-h5';
import { AD_TYPE, AdPluginName, getAdPlugin, H5_PLAY_EVENT, H5_EXT_EVENT, ErrorCode, PLAY_MODE, END_STATE, COMMON_DATA_KEY, BaseCheck, CheckNormalError, PersistedUserSettings, hasGetinfoModule, VIDEO_STATE, getAdReqParams, LOCAL_KEY, H5Player } from '@tencent/thumbplayer-h5';
export * from '@tencent/thumbplayer-h5';
export { H5_EXT_EVENT as PLAY_EVENT_EXT } from '@tencent/thumbplayer-h5';
import { LivepollPlugin, LIVE_EVENTS, LIVE_STATUS } from '@tencent/thumbplayer-plugin-live-poll';
import { UILoadingPlugin } from '@tencent/thumbplayer-plugin-ui-loading';
import * as TVK from '@tencent/thumbplayer-tvk';
import { PAID_FORMAT, CKEY_VRE, getUserCookies, getRequestParamForPaidFormat, enableTVK, ProxyHttp, COOKIE_NAME, VodGetinfo, LiveGetinfo } from '@tencent/thumbplayer-tvk';
export { CKEY_VRE, PAID_FORMAT } from '@tencent/thumbplayer-tvk';
import { isMobile } from '@tencent/thumbplayer-plugin-utils';

var superPlayerI18nConfig = {
    // Tips 插件文案
    TIPS_DEGRADE_TEXT_REASON: '正在缓冲中...',
    TIPS_DEGRADE_TEXT_NO_REASON: '重新请求视频信息...',
    // ErrorPage 文案
    ERROR_PAGE_REPORT_SUCCESS: '日志上报成功',
    ERROR_PAGE_REPORT_FAILED: '日志上报失败 $0',
    // 清晰度切换文案
    DEFN_SWITCHING: '正在为您切换清晰度[$0]',
    DEFN_SWITCH_FAILED: '抱歉，切换清晰度失败~',
    DEFN_SWITCH_SUCCESS: '已为您切换到清晰度[$0]',
    // 音轨切换文案
    AUDIO_SWITCHING: '正在为您切换音轨[$0]',
    AUDIO_SWITCH_FAILED: '抱歉，切换音轨失败~',
    AUDIO_SWITCH_SUCCESS: '已为您切换到音轨[$0]',
    // 直播结束文案
    LIVE_STREAM_END: '直播已结束',
    // SuperPlayer load 接口参数检查错误
    ERROR_LOAD_PARAM_NOT_SUPPORT: '直播模式不支持load()接口',
    ERROR_VID_NOT_SUPPORT: '直播模式不支持传入vid',
    ERROR_CNLID_NOT_SUPPORT: '点播模式不支持传入cnlid',
    ERROR_VID_INVALID: 'vid参数非法',
    // 试看
    PREVIEW_TIPS: '可试看 $0，去腾讯视频观看完整版 <a target="_blank;" href="$1">立即前往</a>',
};
defaultI18nConfig.superPlayer = superPlayerI18nConfig;

/** 桌面端使用的广告插件版本号 */
var webAdVersion = '3.2.50';
/** 移动端使用的广告插件版本号 */
var h5AdVersion = '3.2.30';
/** 广告插件全局变量名 */
var adGlobalName = 'CreativePlayerPlugin';
/** 广告cdn版本号 */
var adVersion = uaTool.mobile ? h5AdVersion : webAdVersion;
/** 广告js最大加载时长 */
var adScriptMaxLoadTime = 10e3;

/** 免前贴广告 域名白名单 */
var skipAdDomainWhiteList = [
    // 新闻插件的量很大，广告侧要求直接根据域名屏蔽前贴
    'e.news.qq.com',
];
var isInDomainWhiteList = skipAdDomainWhiteList.includes(window.location.hostname);

/* eslint-disable @typescript-eslint/naming-convention */
var ErrorPagePluginName = 'error-page';
var ErrorPagePluginEvents = { REPORT_LOG: 'error-page:report-log' };
/** 默认错误文案 */
var defaultErrorText = '出错啦';
var defaultErrorMsg = '这个视频被外星人劫走，暂时看不了了~';
var dataRoleMap = {
    error: 'txp-ui-error',
    errorMsg: 'txp-ui-error-msg',
    errorHandler: 'txp-ui-error-handler',
    errorRefresh: 'txp-ui-error-refresh',
    errorCode: 'txp-ui-error-code',
    background: 'txp-ui-error-background',
    clientBtn: 'txp-ui-error-client-btn',
    browserTip: 'txp-ui-error-browser',
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/** 热点广播的事件 */
var HOTPOINT_EVENTS;
(function (HOTPOINT_EVENTS) {
    HOTPOINT_EVENTS["HOT_MOUSE_OVER"] = "ctrl:hotpoint-mouseover";
    HOTPOINT_EVENTS["HOT_MOUSE_MOVE"] = "ctrl:hotpoint-mousemove";
    HOTPOINT_EVENTS["HOT_MOUSE_OUT"] = "ctrl:hotpoint-mouseout";
})(HOTPOINT_EVENTS || (HOTPOINT_EVENTS = {}));
var CtrlbarPluginName = 'ctrlbar';
/** 控制栏插件上广播的事件 */
var CTRL_EVENTS = __assign(__assign({ 
    /** 全屏状态变化 */
    FULLSCREEN_CHANGE: 'windowFullscreenChange', 
    /** 进入/退出全屏错误 */
    FULLSCREEN_ERROR: 'fullscreenError', 
    /** 伪全屏全屏状态变化 */
    FAKE_FULLSCREEN_CHANGE: 'browserFullscreenChange', 
    /** 点击画中画按钮 */
    CLICK_PIPBTN: 'ctrl:click-pipbtn', 
    /** 点击下一集按钮 */
    CLICK_NEXTBTN: 'ctrl:click-nextbtn', 
    /** 点击播放按钮 */
    CLICK_PLAYBTN: 'ctrl:click-playbtn', 
    /** 点击重播 */
    CLICK_REPLAY: 'ctrl:click-replay', 
    /** 点击循环播放按钮 */
    CLICK_LOOP: 'ctrl:click-loop', 
    /** 点击多语言 */
    SET_LANGUAGE: 'ctrl:set-language', 
    /** 点击清晰度 */
    SET_LEVEL: 'ctrl:set-level', 
    /** 点击多音轨 */
    SET_AUDIO: 'ctrl:set-audio', 
    /** 点击倍速 */
    SET_PLAYRATE: 'ctrl:set-playrate', 
    /** 拖拽音量 */
    SET_VOLUME: 'ctrl:set-volume', 
    /** 移动端浮层切换显隐 */
    TOGGLE_OVERLAY: 'ctrl:toggle-overlay', 
    /** @deprecated 拼写有错误，建议使用 MOUSE_DOWN，后续将删除 */
    MOUSE_DONW: 'ctrl:progress-mousedown', 
    /** 进度条 mousedown */
    MOUSE_DOWN: 'ctrl:progress-mousedown', 
    /** 进度条mousemove */
    MOUSE_MOVE: 'ctrl:progress-mousemove', 
    /** 进度条mouseup */
    MOUSE_UP: 'ctrl:progress-mouseup', 
    /** 进度条展示 */
    SHOW: 'ctrl:show', 
    /** 进度条隐藏 */
    HIDE: 'ctrl:hide' }, HOTPOINT_EVENTS), { 
    /** @ignore 移动端点击时间彩蛋事件，仅内部使用 */
    TEST_EVENT: 'ctrl:inner-test-event', 
    /** 控制栏尺寸发生变化，在进入全屏/伪全屏时广播 */
    RESIZE: 'ctrl:resize', 
    /** 展示清晰度浮层 */
    SHOW_LEVELS: 'ctrl:show-levels', 
    /** 鼠标hover至进度条上 */
    HOVER_PROGRESS: 'ctrl:hover-progress' });
/** web控制栏根元素class名 */
var pcRootClassName = '.plugin_ctrl_txp_bottom';
/** mobile控制栏根元素class名 */
var mobileRootClassName = '.plugin_ctrl_mobile_txp_bottom';
/** 控制栏根元素class名 */
var getRootClassName = function (mobile) { return (mobile ? mobileRootClassName : pcRootClassName); };
var shadowClassName = '.plugin_ctrl_txp_shadow';
var gradientClassName = '.plugin_ctrl_txp_gradient_bottom';
var containerClassName = '_mod_thumbplayer_container_';
var largeSizeClassName = 'plugin_ctrl--large';
var bodyOverflowClassName = 'plugin_ctrl_fake_fullscreen';
var CTRL_SIZE;
(function (CTRL_SIZE) {
    CTRL_SIZE["LARGE"] = "large";
    CTRL_SIZE["NORMAL"] = "normal";
})(CTRL_SIZE || (CTRL_SIZE = {}));
var PlayBtnStatus;
(function (PlayBtnStatus) {
    PlayBtnStatus["PAUSE"] = "pause";
    PlayBtnStatus["PLAY"] = "play";
    PlayBtnStatus["REPLAY"] = "replay";
    PlayBtnStatus["STOP"] = "stop";
})(PlayBtnStatus || (PlayBtnStatus = {}));

/**
 * 暂停时展示在右上角的信息面板入口 ICON
 */
var INFO_SVG_DOM_STR = /* html */ "<div class=\"txp_info_icon txp_none\">\n  <svg\n  viewBox=\"0 0 1024 1024\"\n  version=\"1.1\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n  >\n  <path\n    d=\"M512 958.016C266.08 958.016 65.984 757.952 65.984 512 65.984 266.08 266.08 65.984 512 65.984c245.952 0 446.016 200.064 446.016 446.016C958.016 757.952 757.952 958.016 512 958.016zM512 129.984C301.344 129.984 129.984 301.344 129.984 512c0 210.624 171.36 382.016 382.016 382.016 210.624 0 382.016-171.36 382.016-382.016C894.016 301.344 722.624 129.984 512 129.984z\"\n  ></path>\n  <path\n    d=\"M512 304m-48 0a1.5 1.5 0 1 0 96 0 1.5 1.5 0 1 0-96 0Z\"\n  ></path>\n  <path\n    d=\"M512 768c-17.664 0-32-14.304-32-32l0-288c0-17.664 14.336-32 32-32s32 14.336 32 32l0 288C544 753.696 529.664 768 512 768z\"\n  ></path>\n  </svg>\n</div>\n";
var InfoPanelPluginName = 'info-panel';
var InfoPanelEvents = {
    CLICK_UPLOAD: 'contextmenu:click-upload',
};
var DEFAULT_SHOW_QUERY = 'show_info_panel';

/* eslint-disable @typescript-eslint/naming-convention */
var PosterPluginName = 'poster';
var hideClass = 'txp_none';
var POSTER_IMAGE_ALT = 'Thumbplayer Poster Plugin Image';
var POSTER_IMAGE_CLASS_NAME = 'txp_poster_img';

/* eslint-disable @typescript-eslint/naming-convention */
/** show默认展示3s */
var defaultShowTime = 3;
/** 控制栏隐藏时增加此类名 */
var classNameOnCtrlHide = 'ctrl_hide';
/** 控制栏resize时增加此类名 */
var classNameOnCtrlResize = 'ctrl_resize';
/** 插件名 */
var TipsPluginName = 'tips';

var UIContextMenuPluginName = 'context-menu';

/* eslint-disable @typescript-eslint/naming-convention */
var WaterMarkCoverClassName = 'thumbplayer-watermark-cover';
var WatermarkPluginName = 'ui-watermark';
var MaxRequestRetry = 3;
var RequestTimeout = 5000;
var WatermarkError;
(function (WatermarkError) {
    WatermarkError["ActionWatermarkRequestFailed"] = "001";
})(WatermarkError || (WatermarkError = {}));

var PLUGINS_URL = "//vm.gtimg.cn/thumbplayer/plugins/thumbplayer-plugin-super-player-plugins/".concat("~1.5.12", "/index.min.js");
var LAZY_PLUGINS = [
    TipsPluginName,
    ErrorPagePluginName,
    PosterPluginName,
    CtrlbarPluginName,
    InfoPanelPluginName,
    WatermarkPluginName,
    UIContextMenuPluginName,
];

/** 默认内置的平台号 */
var BUILDIN_PLATFORM;
(function (BUILDIN_PLATFORM) {
    /** 点播站内（v站） */
    BUILDIN_PLATFORM["VOD_INSITE"] = "10201";
    /** 点播站外（非v站） */
    BUILDIN_PLATFORM["VOD_OUTSITE"] = "70201";
    /** 直播站内 */
    BUILDIN_PLATFORM["LIVE_INSITE"] = "10201";
})(BUILDIN_PLATFORM || (BUILDIN_PLATFORM = {}));
/**
 * 外部指定使用哪种编码来播放视频（仅针对腾讯视频业务）
 */
var PLAY_CODEC = {
    AUTO: 0,
    H264: 1,
    H265: 2,
};
/** 后台支持hevc等级的参数枚举（腾讯视频的点播和直播的hevclv字段是对齐的） */
var HEVC_LV_VALUE;
(function (HEVC_LV_VALUE) {
    HEVC_LV_VALUE[HEVC_LV_VALUE["AUTO"] = void 0] = "AUTO";
    HEVC_LV_VALUE[HEVC_LV_VALUE["NOT_SPT"] = 0] = "NOT_SPT";
    /** hevc标清（sd） */
    HEVC_LV_VALUE[HEVC_LV_VALUE["SD"] = 11] = "SD";
    /** hevc高清（hd） */
    HEVC_LV_VALUE[HEVC_LV_VALUE["HD"] = 16] = "HD";
    /** hevc超清（shd） */
    HEVC_LV_VALUE[HEVC_LV_VALUE["SHD"] = 21] = "SHD";
    /** hevc-蓝光（fhd） */
    HEVC_LV_VALUE[HEVC_LV_VALUE["FHD"] = 26] = "FHD";
    /** hevc 4k */
    HEVC_LV_VALUE[HEVC_LV_VALUE["UHD"] = 28] = "UHD";
    /** 只给hevc-uhd(无低清晰度hevc） */
    HEVC_LV_VALUE[HEVC_LV_VALUE["UHD_ONLY"] = 31] = "UHD_ONLY";
})(HEVC_LV_VALUE || (HEVC_LV_VALUE = {}));
/**
 * 在superplayer这一层定义的播放结束状态枚举
 */
var SUPER_END_STATE;
(function (SUPER_END_STATE) {
    /** 试看结束 */
    SUPER_END_STATE["PREVIEW"] = "preview";
})(SUPER_END_STATE || (SUPER_END_STATE = {}));
/** superplayer这一层部分的业务data key */
var SUPER_DATA_KEY;
(function (SUPER_DATA_KEY) {
    SUPER_DATA_KEY["vodCGIUsed"] = "super:cgiUsed";
    /** 从getinfo拿到的广告信息，包括广告sessionid，hls中插时间段、植入广告信息等 */
    SUPER_DATA_KEY["getinfoAdInfo"] = "getinfoAdInfo";
    /** hls中插的时间段，由后台下发 */
    SUPER_DATA_KEY["hlsAdRanges"] = "hlsAdRanges";
})(SUPER_DATA_KEY || (SUPER_DATA_KEY = {}));
var LOCAL_STORAGE_KEY = {
    /** 缓存key */
    ENV_CACHE: '__thumbplayer_env_cache',
    RENDER_STATS_INFO: '__thumbplayer_render_stats_info',
    DEGRADE_CODEC_TIME: '__thumbplayer_degradecodec_time',
    DYNAMIC_CONFIG: '__thumbplayer_dynamic_config',
};
var ctrlbarPluginName = CtrlbarPluginName;
var contextMenuPluginName = UIContextMenuPluginName;

var SuperPlayerEnum = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get BUILDIN_PLATFORM () { return BUILDIN_PLATFORM; },
  PLAY_CODEC: PLAY_CODEC,
  get HEVC_LV_VALUE () { return HEVC_LV_VALUE; },
  get SUPER_END_STATE () { return SUPER_END_STATE; },
  get SUPER_DATA_KEY () { return SUPER_DATA_KEY; },
  LOCAL_STORAGE_KEY: LOCAL_STORAGE_KEY,
  ctrlbarPluginName: ctrlbarPluginName,
  contextMenuPluginName: contextMenuPluginName,
  adGlobalName: adGlobalName,
  adVersion: adVersion,
  adScriptMaxLoadTime: adScriptMaxLoadTime,
  skipAdDomainWhiteList: skipAdDomainWhiteList,
  isInDomainWhiteList: isInDomainWhiteList,
  CTRL_EVENTS: CTRL_EVENTS,
  get CTRL_SIZE () { return CTRL_SIZE; },
  CtrlbarPluginName: CtrlbarPluginName,
  DEFAULT_SHOW_QUERY: DEFAULT_SHOW_QUERY,
  ErrorPagePluginEvents: ErrorPagePluginEvents,
  ErrorPagePluginName: ErrorPagePluginName,
  get HOTPOINT_EVENTS () { return HOTPOINT_EVENTS; },
  INFO_SVG_DOM_STR: INFO_SVG_DOM_STR,
  InfoPanelEvents: InfoPanelEvents,
  InfoPanelPluginName: InfoPanelPluginName,
  MaxRequestRetry: MaxRequestRetry,
  POSTER_IMAGE_ALT: POSTER_IMAGE_ALT,
  POSTER_IMAGE_CLASS_NAME: POSTER_IMAGE_CLASS_NAME,
  get PlayBtnStatus () { return PlayBtnStatus; },
  PosterPluginName: PosterPluginName,
  RequestTimeout: RequestTimeout,
  TipsPluginName: TipsPluginName,
  UIContextMenuPluginName: UIContextMenuPluginName,
  WaterMarkCoverClassName: WaterMarkCoverClassName,
  get WatermarkError () { return WatermarkError; },
  WatermarkPluginName: WatermarkPluginName,
  bodyOverflowClassName: bodyOverflowClassName,
  classNameOnCtrlHide: classNameOnCtrlHide,
  classNameOnCtrlResize: classNameOnCtrlResize,
  containerClassName: containerClassName,
  dataRoleMap: dataRoleMap,
  defaultErrorMsg: defaultErrorMsg,
  defaultErrorText: defaultErrorText,
  defaultShowTime: defaultShowTime,
  getRootClassName: getRootClassName,
  gradientClassName: gradientClassName,
  hideClass: hideClass,
  largeSizeClassName: largeSizeClassName,
  mobileRootClassName: mobileRootClassName,
  pcRootClassName: pcRootClassName,
  shadowClassName: shadowClassName,
  PLUGINS_URL: PLUGINS_URL,
  LAZY_PLUGINS: LAZY_PLUGINS
});

/**
 * super-player这一层产生的事件类型枚举
 * SuperPlayer 扩展事件，在与各插件整合后的流程中产生并抛出
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
var SUPER_EVENTS;
(function (SUPER_EVENTS) {
    /** 降级编码播放，使用h265我们使用较低性能的wasm内核播放，如果性能跟不上，降级到原生的h264播放（硬解）*/
    SUPER_EVENTS["DEGRADE_CODEC"] = "degradeCodec";
    /** 试看开始 */
    SUPER_EVENTS["PREVIEW_START"] = "previewStart";
    /** 试看结束 */
    SUPER_EVENTS["PREVIEW_END"] = "previewEnd";
    /** get_video_mark_all请求返回 */
    SUPER_EVENTS["GET_VIDEO_MARK_ALL_OVER"] = "getVideoMarkAllOver";
    /** 进入hls中插广告 */
    SUPER_EVENTS["ENTER_HLS_AD"] = "enterHlsAd";
    /** 退出hls中插广告 */
    SUPER_EVENTS["EXIT_HLS_AD"] = "exitHlsAd";
})(SUPER_EVENTS || (SUPER_EVENTS = {}));

var SuperPlayerEvt = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get SUPER_EVENTS () { return SUPER_EVENTS; }
});

var coreExportKeys = [
    'PLAY_EVENT',
    'VIDEO_STATE',
    'KERNEL_NAME',
    'PLAY_MODE',
    'END_STATE',
    'EvtEmitter',
    'kernelEvtBus',
    'preloadEvtBus',
    'PAUSE_TYPE',
    'commonTool',
    'uaTool',
    'Logger',
    'cookieTool',
    'lsTool',
    'urlTool',
    'domTool',
    'netTool',
    'videoTool',
    'stringTool',
    'VIDEO_CODEC',
    'AUDIO_CODEC',
    'CONTAINER_FORMAT',
];
var h5ExportKeys = [
    'H5_PLAY_EVENT',
    'COMMON_DATA_KEY',
    'DATA_EVENTS',
    'DRM_TYPE',
    'DRM_VALUE',
    'H5_EXT_EVENT',
    'AdPluginName',
    'FullScreenMode',
    'Plugin',
];
var superPlayerExportKeys = [
    'PLAY_CODEC',
    'CTRL_EVENTS',
    'SUPER_END_STATE',
    'SUPER_EVENTS',
    'ctrlbarPluginName',
    'contextMenuPluginName',
];
var tvkExportKeys = [
    'TVK_EVENTS',
    'TVK_EVENT_DETAILS',
];
/**
 * 绑定导出对象到SuperPlayer类对象上。用于绑定core和h5模块中指定的导出到SuperPlayer对象上。例如将h5模块中的`H5_PLAY_EVENT`对象绑定到
 * SuperPlayer.H5_PLAY_EVENT，引用方引入时只需要展开SuperPlayer对象：
 * ```javascript
 * const { SuperPlayer } = window;
 * const { H5_PLAY_EVENT } = SuperPlayer;
 * ```
 *
 * 注意！一定要注意不能覆盖SuperPlayer对象上已定义的static属性，后续有增加导出需检查
 */
function bindExports(targetExports) {
    var exportKeys = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], coreExportKeys, true), h5ExportKeys, true), superPlayerExportKeys, true), tvkExportKeys, true);
    // 在targetExports上已经有的key，不能覆盖
    exportKeys = exportKeys.filter(function (key) { return typeof targetExports[key] === 'undefined'; });
    exportKeys.forEach(function (key) {
        [ThumbPlayerH5, ThumbPlayerCore, SuperPlayerEnum, SuperPlayerEvt, TVK].forEach(function (sourceExport) {
            if (sourceExport === null || sourceExport === void 0 ? void 0 : sourceExport[key]) {
                targetExports[key] = sourceExport[key];
            }
        });
    });
}

var _a;
/** 状态枚举 */
var STATE;
(function (STATE) {
    STATE[STATE["enabled"] = 0] = "enabled";
    STATE[STATE["disabled"] = 1] = "disabled";
})(STATE || (STATE = {}));
/** 广告类型枚举 */
var AdType = {
    MidRoll: 'ZC',
    HlsAd: 'PHLS',
    BeforePlay: AD_TYPE.PRE,
    BeforePlayCodeName: 'LD',
    AfterPlay: AD_TYPE.POST,
    AfterPlayCodeName: 'HT',
};
var AD_INFO_OP_TYPE;
(function (AD_INFO_OP_TYPE) {
    AD_INFO_OP_TYPE[AD_INFO_OP_TYPE["HLS_AD"] = 2] = "HLS_AD";
})(AD_INFO_OP_TYPE || (AD_INFO_OP_TYPE = {}));
var disabledCtrlBarComps = [
    // popups
    'playrate',
    'definition',
    'audiotrack',
    'language',
    // ctrlbar组件
    'PlayBtn',
    'NextBtn',
    'Progress',
    'CtrlShow',
    'PictureInPicture',
];
var disabledCtrlBarCompsWhenHlsAd = [
    'playrate',
    'definition',
    'audiotrack',
    'language',
];
/**
 * 各种广告类型禁用控件的映射表
 */
var disabledCtrlBarCompsMap = (_a = {},
    _a[AdType.AfterPlay] = disabledCtrlBarComps,
    _a[AdType.BeforePlay] = disabledCtrlBarComps,
    _a[AdType.MidRoll] = disabledCtrlBarComps,
    _a[AdType.HlsAd] = disabledCtrlBarCompsWhenHlsAd,
    _a);

/**
 * 从getinfo解析hls中插的时间段
 */
function parseGetinfoHlsAdRanges(getinfoAdInfo) {
    var _a;
    var adTimeRanges = [];
    if (!(getinfoAdInfo === null || getinfoAdInfo === void 0 ? void 0 : getinfoAdInfo.adpinfo)) {
        return adTimeRanges;
    }
    // 和后台字段对齐
    // eslint-disable-next-line camelcase
    var adpinfoData = null;
    try {
        adpinfoData = JSON.parse(getinfoAdInfo.adpinfo);
    }
    catch (e) {
    }
    (_a = adpinfoData === null || adpinfoData === void 0 ? void 0 : adpinfoData.plugin_info) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
        if (+item.optype !== AD_INFO_OP_TYPE.HLS_AD) {
            return;
        }
        adTimeRanges.push({
            start: item.ad_offset_time,
            end: item.ad_offset_time + item.ad_dura,
        });
    });
    return adTimeRanges;
}

/**
 * 在super-player这一层的广告逻辑处理。
 */
var AdLogic = /** @class */ (function () {
    function AdLogic(player, corePlayer) {
        var _this = this;
        this.player = player;
        this.corePlayer = corePlayer;
        /** hls中插广告是否正在播放 */
        this.isHlsAdPlaying = false;
        /** hls中插点位信息 */
        this.adSlotInfo = [];
        this.logger = new Logger(this.player.config.instanceId, 'AdLogic');
        this.setEvts(true);
        this.player.pluginMsg.once("pluginsetup:".concat(AdPluginName), function () {
            var _a, _b;
            _this.adPlugin = getAdPlugin(_this.player.config.instanceId);
            if (uaTool.browser.safari) {
                (_b = (_a = _this.adPlugin).setPhlsPlayType) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
            _this.setAdPluginEvts(true);
        });
    }
    AdLogic.prototype.destroy = function () {
        if (getAdPlugin(this.player.config.instanceId)) {
            this.setAdPluginEvts(false);
        }
        this.setEvts(false);
        this.player = null;
        this.corePlayer = null;
    };
    AdLogic.prototype.setEvts = function (value) {
        var _a, _b;
        var _this = this;
        if (!this.evtMap) {
            this.evtMap = {
                player: (_a = {},
                    _a[H5_PLAY_EVENT.AD_PLAYING] = this.onAdPlaying.bind(this),
                    _a[H5_PLAY_EVENT.AD_END] = this.onAdEnd.bind(this),
                    _a[H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED] = this.onAdAutoplayBlocked.bind(this),
                    _a[H5_PLAY_EVENT.VIDEO_TIMEUPDATE] = this.onVideoTimeUpdate.bind(this),
                    _a[H5_PLAY_EVENT.AD_PAUSE] = this.onAdPaused.bind(this),
                    _a[H5_PLAY_EVENT.AD_RESUME] = this.onAdResume.bind(this),
                    _a[PLAY_EVENT.ENTER_INSERT_STREAM] = this.onEnterInsertStream.bind(this),
                    _a[PLAY_EVENT.EXIT_INSERT_STREAM] = this.onExitInsertStream.bind(this),
                    _a),
                adPlugin: {
                    enterCountdownCompleteEvt: this.onWillPlayMidRollAd.bind(this),
                    enterCountdownEvt: this.onEnterMidRollAdCountdown.bind(this),
                },
                msg: (_b = {},
                    _b[H5_EXT_EVENT.GETINFO_OVER] = this.onVideoReqInfoEnd.bind(this),
                    _b),
            };
        }
        var func = value ? this.player.on : this.player.off;
        Object.keys(this.evtMap.player).forEach(function (evtName) {
            func.apply(_this.player, [evtName, _this.evtMap.player[evtName]]);
        });
        var pluginMsgFunc = value ? this.player.on : this.player.off;
        Object.keys(this.evtMap.msg).forEach(function (evtName) {
            pluginMsgFunc.apply(_this.player.pluginMsg, [evtName, _this.evtMap.msg[evtName]]);
        });
    };
    AdLogic.prototype.setAdPluginEvts = function (value) {
        var _this = this;
        var adPlugin = getAdPlugin(this.player.config.instanceId);
        var adFuncs = value ? adPlugin.on : adPlugin.off;
        Object.keys(this.evtMap.adPlugin).forEach(function (evtName) {
            adFuncs.apply(adPlugin, [evtName, _this.evtMap.adPlugin[evtName]]);
        });
    };
    AdLogic.prototype.onAdPlaying = function (event) {
        var _a;
        var _this = this;
        var _b, _c, _d;
        var jobs = (_a = {},
            _a[AdType.BeforePlay] = function () { return _this.setCtrlBarState(STATE.disabled, AdType.BeforePlay); },
            _a[AdType.MidRoll] = function () { return _this.setCtrlBarState(STATE.disabled, AdType.MidRoll); },
            _a[AdType.AfterPlay] = function () { return _this.setCtrlBarState(STATE.disabled, AdType.AfterPlay); },
            _a);
        var adType = (_b = event.data) === null || _b === void 0 ? void 0 : _b.adType;
        (_c = jobs[adType]) === null || _c === void 0 ? void 0 : _c.apply(this);
        (_d = this.player.loadingPlugin) === null || _d === void 0 ? void 0 : _d.hide();
    };
    AdLogic.prototype.onAdPaused = function () {
        // 因为任何原因导致的广告暂停，都需要解除控制栏的限制，避免卡死。
        var ctrlbarPlugin = this.player.ctrlbarPlugin;
        if (!ctrlbarPlugin || uaTool.mobile)
            return;
        ctrlbarPlugin.show(true);
        ctrlbarPlugin.setCompDisable('PlayBtn', false);
    };
    AdLogic.prototype.onAdResume = function (_a) {
        var data = _a.data;
        // todo 标准化事件
        var adtype = data.adtype;
        // 这里用LD，HT等广告插件实际使用的类型名，因为事件是从广告插件直接监听的，尚未标准化
        var targetAdtype = [AdType.AfterPlayCodeName, AdType.MidRoll, AdType.BeforePlayCodeName];
        var ctrlbarPlugin = this.player.ctrlbarPlugin;
        if (!ctrlbarPlugin || uaTool.mobile)
            return;
        if (targetAdtype.includes(adtype)) {
            ctrlbarPlugin.setCompDisable('PlayBtn');
        }
    };
    AdLogic.prototype.onAdEnd = function (event) {
        var _a;
        var _this = this;
        var _b, _c;
        var jobs = (_a = {},
            _a[AdType.BeforePlay] = function () { return _this.setCtrlBarState(STATE.enabled, AdType.BeforePlay); },
            _a[AdType.MidRoll] = function () {
                _this.setCtrlBarState(STATE.enabled, AdType.MidRoll);
                _this.player.play();
            },
            _a[AdType.AfterPlay] = function () { return _this.setCtrlBarState(STATE.enabled, AdType.AfterPlay); },
            _a);
        var adType = (_b = event.data) === null || _b === void 0 ? void 0 : _b.adType;
        (_c = jobs[adType]) === null || _c === void 0 ? void 0 : _c.apply(this);
    };
    AdLogic.prototype.onAdAutoplayBlocked = function (_a) {
        var _b;
        var data = _a.data;
        if (data.adType !== AdType.BeforePlay) {
            // 只有前贴广告需要处理自动播放被阻止的逻辑
            return;
        }
        // 广告被自动播放拦截的时候，处于等待状态，需要隐藏掉loading动画
        (_b = this.player.loadingPlugin) === null || _b === void 0 ? void 0 : _b.hide();
        // 广告自动播放被拦截时展示控制栏，解除播放按钮禁用
        var ctrlbarPlugin = this.player.ctrlbarPlugin;
        if (!ctrlbarPlugin)
            return;
        ctrlbarPlugin.show(true);
        ctrlbarPlugin.setCompDisable('PlayBtn', false);
        ctrlbarPlugin.setCompDisable(['PictureInPicture', 'playrate'], true);
    };
    AdLogic.prototype.onWillPlayMidRollAd = function () {
        this.player.pause();
        getAdPlugin(this.player.config.instanceId).playAd({ adType: AdType.MidRoll });
    };
    AdLogic.prototype.onEnterMidRollAdCountdown = function () {
        this.setCtrlBarState(STATE.disabled, AdType.MidRoll);
    };
    /**
     * 禁用/解禁一些ui操作
     */
    AdLogic.prototype.setCtrlBarState = function (disabled, adType) {
        var ctrlbarPlugin = this.player.plugins[CtrlbarPluginName];
        if (!ctrlbarPlugin) {
            return;
        }
        var ctrlBarCompDisableArr = disabledCtrlBarCompsMap[adType];
        ctrlbarPlugin.setCompDisable(ctrlBarCompDisableArr, !!disabled);
        switch (adType) {
            case AdType.HlsAd:
                // HlsAd标版时不禁用控制组件
                break;
            default:
                ctrlbarPlugin.setHotKeysDisable(!!disabled);
                break;
        }
    };
    AdLogic.prototype.onVideoReqInfoEnd = function (evt) {
        var _a, _b, _c, _d;
        var data = evt.data;
        var vitem = ((data === null || data === void 0 ? void 0 : data.parseData) || {}).vitem;
        if (data === null || data === void 0 ? void 0 : data.error)
            return;
        if (!(vitem === null || vitem === void 0 ? void 0 : vitem.ad)) {
            // 每次请求完，如果没有广告，则需要重置
            this.player.setCommonKv(SUPER_DATA_KEY.hlsAdRanges, null);
            this.player.setCommonKv(SUPER_DATA_KEY.getinfoAdInfo, null);
            return;
        }
        var getinfoHlsAdRanges = parseGetinfoHlsAdRanges(vitem.ad);
        this.player.setCommonKv(SUPER_DATA_KEY.hlsAdRanges, getinfoHlsAdRanges);
        this.player.setCommonKv(SUPER_DATA_KEY.getinfoAdInfo, vitem.ad);
        this.adSlotInfo = commonTool.mergeTimeRanges((_d = (_c = (_b = (_a = data.parseData) === null || _a === void 0 ? void 0 : _a.supplementaryInfo) === null || _b === void 0 ? void 0 : _b.contentInfo) === null || _c === void 0 ? void 0 : _c.ad) !== null && _d !== void 0 ? _d : []);
        this.logger.log('hlsAdRanges from getinfo is ', getinfoHlsAdRanges);
    };
    AdLogic.prototype.onVideoTimeUpdate = function (evt) {
        var data = evt.data;
        var playtime = (data || {}).playtime;
        if (
        // safari下使用兼容模式，不使用timeupdate事件
        uaTool.browser.safari
            // 非法播放时间
            || playtime <= 0) {
            return;
        }
        this.checkWhetherEnterOrExitHlsAd(playtime);
    };
    /**
     * 检查是否进入或者退出hls中插广告区间
     * @param playtime 当前播放时间
     * @returns
     */
    AdLogic.prototype.checkWhetherEnterOrExitHlsAd = function (playtime) {
        var hlsAdRanges = this.player.getCommonKv(SUPER_DATA_KEY.hlsAdRanges);
        if (!hlsAdRanges || hlsAdRanges.length <= 0) {
            // 没有hls中插区间, 避免新清晰度因异常没有中插信息导致的变量无法重置
            this.exitHlsAd();
            return;
        }
        var hlsAdRange = hlsAdRanges.find(function (range) { return range.start <= playtime && playtime <= range.end; });
        if (!this.isHlsAdPlaying && hlsAdRange) {
            this.enterHlsAd(playtime, hlsAdRange);
        }
        else if (this.isHlsAdPlaying && !hlsAdRange) {
            this.exitHlsAd();
        }
    };
    /**
     * 进入hls中插广告区间
     * @param playtime 当前播放时间
     * @param hlsAdRange 进入的区间范围
     */
    AdLogic.prototype.enterHlsAd = function (playtime, hlsAdRange) {
        if (this.isHlsAdPlaying)
            return;
        this.logger.log("enter hlsAd, playtime=".concat(playtime, ", range="), hlsAdRange);
        this.isHlsAdPlaying = true;
        this.player.emit(SUPER_EVENTS.ENTER_HLS_AD, { hlsAdRange: hlsAdRange });
    };
    AdLogic.prototype.exitHlsAd = function () {
        if (!this.isHlsAdPlaying)
            return;
        this.logger.log('exit hlsAd....');
        this.isHlsAdPlaying = false;
        this.player.emit(SUPER_EVENTS.EXIT_HLS_AD);
    };
    AdLogic.prototype.onEnterInsertStream = function (evt) {
        var _a, _b, _c, _d;
        var index = ((_a = evt === null || evt === void 0 ? void 0 : evt.data) !== null && _a !== void 0 ? _a : {}).index;
        this.logger.log('enter insert stream', this.adSlotInfo[index]);
        var slot = (_b = this.adSlotInfo) === null || _b === void 0 ? void 0 : _b[index];
        if (slot) {
            this.setCtrlBarState(STATE.disabled, AdType.HlsAd);
            (_d = (_c = this.adPlugin) === null || _c === void 0 ? void 0 : _c.startSoloPlayPhls) === null || _d === void 0 ? void 0 : _d.call(_c, slot.start);
            this.player.emit(H5_PLAY_EVENT.AD_PLAYING, { adType: AdType.HlsAd });
        }
    };
    AdLogic.prototype.onExitInsertStream = function (evt) {
        var _a, _b, _c;
        var index = ((_a = evt === null || evt === void 0 ? void 0 : evt.data) !== null && _a !== void 0 ? _a : {}).index;
        this.logger.log('exit insert stream', this.adSlotInfo[index]);
        this.setCtrlBarState(STATE.enabled, AdType.HlsAd);
        (_c = (_b = this.adPlugin) === null || _b === void 0 ? void 0 : _b.endSoloPlayPhls) === null || _c === void 0 ? void 0 : _c.call(_b);
        this.player.emit(H5_PLAY_EVENT.AD_END, { code: ErrorCode.SUC, adType: AdType.HlsAd });
    };
    return AdLogic;
}());

/**
 * 展示封面图时机：
 * 1. 广告被阻止展示封面图
 * 2. 如果有后贴广告播放，后贴广告结束后腾讯视频点播展示封面图（理论上直播没有后贴）
 * 3. 广告播放期间被 player.stop 打断，展示封面图
 */
var PosterLogic = /** @class */ (function () {
    function PosterLogic(player) {
        this.player = player;
        /** session内是否有后贴广告播放 */
        this.hasPostAdInPlaySession = false;
        this.setEvts(true);
        this.showDefaultPoster();
    }
    PosterLogic.prototype.destroy = function () {
        this.setEvts(false);
        this.player = null;
    };
    /**
     * 根据superplayer配置中的videoid显示默认封面图
     */
    PosterLogic.prototype.showDefaultPoster = function () {
        var _this = this;
        var _a = this.player.config, videoId = _a.videoId, type = _a.type, lazyInitPlugins = _a.lazyInitPlugins, videoInitConfig = _a.videoInitConfig;
        var lastVideoId = videoId;
        if (videoInitConfig) {
            if (typeof videoInitConfig === 'string') {
                lastVideoId = videoInitConfig;
            }
            else {
                var vid = videoInitConfig.vid;
                if (vid) {
                    lastVideoId = vid;
                }
            }
        }
        var showVodDefaultPoster = function () {
            if (type === PLAY_MODE.VOD && lastVideoId) {
                // superplayer的配置传videoid默认显示videoid对应的封面图
                _this.showPoster(lastVideoId);
            }
        };
        if (lazyInitPlugins) {
            this.player.pluginMsg.once("pluginsetup:".concat(PosterPluginName), function () {
                showVodDefaultPoster();
            });
        }
        else {
            showVodDefaultPoster();
        }
    };
    /**
     * 显示封面图。腾讯视频点播用vid展示，腾讯视频直播用默认封面图
     */
    PosterLogic.prototype.showPoster = function (vodVid) {
        var _a = this.player.config, poster = _a.poster, disablePoster = _a.disablePoster, type = _a.type;
        var posterPlugin = this.player.getPlugin(PosterPluginName);
        if (disablePoster || !posterPlugin) {
            return;
        }
        if (poster === null || poster === void 0 ? void 0 : poster.src) {
            // 如果有配置直接传入的poster地址，直接展示外部传入
            posterPlugin.show(poster.src);
            return;
        }
        if (type === PLAY_MODE.VOD) {
            if (vodVid && typeof vodVid === 'string') {
                posterPlugin.showByVid(__assign$1(__assign$1({}, poster), { vid: vodVid }));
            }
            return;
        }
        // 直播显示默认封面图
        posterPlugin.show('https://puui.qpic.cn/vupload/0/20171225_1514277750947.jpeg/0');
    };
    PosterLogic.prototype.setEvts = function (value) {
        var _a;
        var _this = this;
        if (!this.evtMap) {
            this.evtMap = (_a = {},
                _a[H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED] = this.onAdAutoplayBlocked.bind(this),
                _a[H5_PLAY_EVENT.AD_PLAYING] = this.onAdPlaying.bind(this),
                _a[H5_PLAY_EVENT.PLAY_SESSION_END] = this.onPlaySessionEnd.bind(this),
                _a);
        }
        var func = value ? this.player.on : this.player.off;
        Object.keys(this.evtMap).forEach(function (evtName) {
            func.apply(_this.player, [evtName, _this.evtMap[evtName]]);
        });
    };
    PosterLogic.prototype.onAdAutoplayBlocked = function (_a) {
        var data = _a.data;
        if (data.adType === AD_TYPE.PRE) {
            // 只有前贴广告需要在被阻止时，显示封面图
            this.showPoster(this.player.vid);
        }
    };
    PosterLogic.prototype.onAdPlaying = function (_a) {
        var data = _a.data;
        if (data.adType === AD_TYPE.POST) {
            this.hasPostAdInPlaySession = true;
        }
    };
    PosterLogic.prototype.waitSessionStart = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var callback = function () { return resolve(true); };
            _this.player.once(H5_PLAY_EVENT.PLAY_SESSION_START, callback);
            setTimeout(function () {
                var _a;
                (_a = _this.player) === null || _a === void 0 ? void 0 : _a.off(H5_PLAY_EVENT.PLAY_SESSION_START, callback);
                resolve(false);
            }, SESSION_DURATION);
        });
    };
    PosterLogic.prototype.onPlaySessionEnd = function (_a) {
        var data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            var curFlowNodeName, endState, isSessionStart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        curFlowNodeName = data.curFlowNodeName, endState = data.endState;
                        // 1. 如果播到了后贴广告，则 SESSION_END 时展示封面图
                        if (this.hasPostAdInPlaySession) {
                            this.hasPostAdInPlaySession = false;
                            this.showPoster(this.player.vid);
                            return [2 /*return*/];
                        }
                        if (!(AD_FLOW_NODE_NAME_REG.test(curFlowNodeName) && endState !== END_STATE.NORMAL)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.waitSessionStart()];
                    case 1:
                        isSessionStart = _b.sent();
                        !isSessionStart && this.showPoster(this.player.vid);
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return PosterLogic;
}());
/**
 * 正则判断节点名是否为广告节点
 */
var AD_FLOW_NODE_NAME_REG = /AdFlowNode/i;
/** SessionStart 与 SessionEnd 时间间隔 */
var SESSION_DURATION = 400;

/** URL注入参数名 */
var UrlParamKey;
(function (UrlParamKey) {
    UrlParamKey["debugSuper"] = "__debugSuper";
    UrlParamKey["logLevel"] = "__logLevel";
    UrlParamKey["downloadKit"] = "__downloadKit";
    UrlParamKey["forceCodec"] = "__forceCodec";
    /** 是否走测试环境请求接口 */
    UrlParamKey["testSrv"] = "__testSrv";
})(UrlParamKey || (UrlParamKey = {}));
/**
 * 检查某些接口的参数合法性
 */
function checkParams(mode, funcName, config) {
    if (!funcName || !config) {
        return;
    }
    var SPI18n = i18nConfig.superPlayer;
    var illegalConds = [
        {
            checker: function () { return mode === PLAY_MODE$1.LIVE && funcName === 'load'; },
            msg: t(SPI18n.ERROR_LOAD_PARAM_NOT_SUPPORT),
        }, {
            checker: function () { return mode === PLAY_MODE$1.LIVE && funcName === 'play' && config.vid; },
            msg: t(SPI18n.ERROR_VID_NOT_SUPPORT),
        }, {
            checker: function () { return mode === PLAY_MODE$1.VOD && config.cnlid; },
            msg: t(SPI18n.ERROR_CNLID_NOT_SUPPORT),
        }, {
            checker: function () { return config.vid && !/^\w{11}$/.test(config.vid); },
            msg: t(SPI18n.ERROR_VID_INVALID),
        },
    ];
    for (var i = 0, len = illegalConds.length; i < len; i++) {
        if (illegalConds[i].checker()) {
            throw new Error(illegalConds[i].msg);
        }
    }
}
/**
 * 将清晰度字符串格式化，例如将字符串”标清;(270P)“转换为数组['标清', '270P']
 */
function formatDefnName(cname, isLive) {
    if (isLive === void 0) { isLive = false; }
    if (isLive)
        return formatLiveDefnName(cname);
    var reg = /(.*);\((.*)\)/;
    var arr = cname === null || cname === void 0 ? void 0 : cname.match(reg);
    if ((arr === null || arr === void 0 ? void 0 : arr.length) >= 3) {
        return [arr[1], arr[2]];
    }
    // 审核部分cgi返回清晰度名称仅包含清晰度（270p，1080p）这里需要做一下兼容
    return [cname !== null && cname !== void 0 ? cname : '', ''];
}
/** 蓝光 1080P -> ['蓝光', '1080P'] */
function formatLiveDefnName(cname) {
    var _a = cname.split(' '), name = _a[0], number = _a[1];
    return [name, number];
}
/**
 * 判断当前环境是否为官方播放
 */
function getIsOfficialScenes() {
    // (.com)是为了避免被 tde 修改
    var conditions = [
        /^http(s?):\/\/v\.qq(\.com)\/x\/(cover|page)\//.test(location.href),
        uaTool.browser.qqlive,
    ];
    return conditions.some(function (i) { return i; });
}
/**
 * 判断当前环境是否是qq域，放开部分策略
 */
function isOfficialDomain() {
    return /^http(s?):\/\/(.*)\.(qq|woa|oa)\.com/.test(location.href);
}
/**
 * 拼接跳转v站链接。
 */
function getTxVideoPageURLByVid(vid, exStr, start) {
    if (!vid) {
        return '';
    }
    if (exStr !== '0') {
        exStr = "_".concat(exStr);
    }
    else {
        exStr = '';
    }
    var homepage = '//v.qq.com/page';
    var part1 = vid.substr(0, 1);
    var part2 = vid.substr(vid.length - 2, 1);
    var part3 = vid.substr(vid.length - 1, 1);
    var url = "".concat(homepage, "/").concat(part1, "/").concat(part2, "/").concat(part3, "/").concat(vid).concat(exStr, ".html");
    if (start) {
        url += "?start=".concat(start);
    }
    return url;
}
/**
 * 获取环境变量。
 */
function getEnvVals() {
    var CHANNEL = 'npm';
    try {
        CHANNEL = "npm";
    }
    catch (_a) { }
    var VERSION = '';
    try {
        VERSION = "1.19.23";
    }
    catch (_b) { }
    var BUILD_TIME = '';
    try {
        BUILD_TIME = "1686292750972";
    }
    catch (_c) { }
    var LOCAL_DEV = false;
    try {
        // @ts-ignore
        LOCAL_DEV = process.env.__LOCAL_DEV__ === '1';
    }
    catch (_d) { }
    var IS_BETA = false;
    try {
        // @ts-ignore
        IS_BETA = "0" === '1';
    }
    catch (_e) { }
    return {
        CHANNEL: CHANNEL,
        VERSION: IS_BETA ? "".concat(VERSION, "-beta") : VERSION,
        BUILD_TIME: BUILD_TIME,
        /** 是否本地调试 */
        LOCAL_DEV: LOCAL_DEV,
    };
}
/** 从url参数读取配置，是否为调试模式 */
function getDebugModeFromUrl() {
    return urlTool.getUrlParamByKey(location.href, UrlParamKey.debugSuper) === '1';
}
/** 从url参数读取配置，打开不同等级的日志 */
function getLogLevelFromUrl() {
    var logLevel = +urlTool.getUrlParamByKey(location.href, UrlParamKey.logLevel);
    if (isNaN(logLevel)) {
        return PLAYER_LOG_LEVEL.NONE;
    }
    return logLevel;
}
function getForceCodecFromUrl() {
    return urlTool.getUrlParamByKey(location.href, UrlParamKey.forceCodec);
}
function getTestProxyHttpPath() {
    return urlTool.getUrlParamByKey(location.href, UrlParamKey.testSrv) === '1' ? '//testvd.l.qq.com/proxyhttp' : void 0;
}

/**
 * 试看逻辑
 * 1. 移动端试看，只允许播后台下发的试看配置时长，播到设置的时间后 stop
 * 2. PC 端试看，只允许播后台下发的试看配置时长，播到设置的时间后 pause
 */
var PreviewLogic = /** @class */ (function () {
    function PreviewLogic(player) {
        var _this = this;
        this.player = player;
        this.previewDuration = NO_PREVIEW_FLAG;
        /** 中间试看的起点 */
        this.previewStartPosition = 0;
        /** 标志是否试看结束，用于区分 Web 下试看结束 pause 事件，防止重复抛出试看结束 */
        this.isPreviewEnd = false;
        /** 试看结束 pause 时，会禁用快捷操作，这里两个变量保存禁用前状态方便恢复 */
        this.lastHotKeysDisabled = false;
        this.lastCtrlShowDisabled = false;
        /** 直播开始试看的时间戳，取+new Date() */
        this.previewStartTimeOnLive = 0;
        /** 剩余的可试看次数 */
        this.previewRemainCount = 0;
        this.onVideoSessionStart = function () {
            if (!_this.ctrlPlugin || !_this.isVod)
                return;
            _this.ctrlPlugin.duration = undefined;
        };
        /**
         * 获取 GET_INFO 返回的试看配置，在 PC 端上，设置控制栏假显
         */
        this.onVideoReqInfoEnd = function (_a) {
            var _b = _a.data, code = _b.code, data = _b.data;
            if (code !== ErrorCode.SUC)
                return;
            var _c = (data === null || data === void 0 ? void 0 : data.parseData) || {}, previewOld = _c.preview, duration = _c.duration, previewRemainCount = _c.previewRemainCount, supplementaryInfo = _c.supplementaryInfo;
            var contentInfo = (supplementaryInfo !== null && supplementaryInfo !== void 0 ? supplementaryInfo : {}).contentInfo;
            var _d = contentInfo !== null && contentInfo !== void 0 ? contentInfo : {}, preview = _d.preview, _e = _d.previewStartPosition, previewStartPosition = _e === void 0 ? 0 : _e;
            var previewUsed = preview !== null && preview !== void 0 ? preview : previewOld;
            // 无需试看或者根本无法试看
            if (Number.isNaN(previewUsed) || previewUsed <= 0)
                return;
            _this.previewDuration = previewUsed;
            _this.previewRemainCount = previewRemainCount;
            _this.previewStartPosition = previewStartPosition;
            if (_this.isVod) {
                _this.showTips();
                // 如果启用了控制栏插件，则设置控制栏假显
                if (_this.ctrlPlugin) {
                    // 移动端则不设置假显，因为移动端如果被劫持以后一定显示的是流时间。而移动端劫持比较常见
                    _this.player.ctrlbarPlugin.duration = uaTool.mobile ? _this.previewDuration : duration;
                    if (!uaTool.mobile) {
                        _this.setCtrlMaxPercent((previewUsed + previewStartPosition) / duration);
                    }
                }
            }
            else {
                // 直播试看开始
                _this.showTips();
            }
            _this.player.emit(SUPER_EVENTS.PREVIEW_START, { previewDuration: previewUsed, previewStartPosition: previewStartPosition });
        };
        /**
         * 如果试看结束后，因为如切清晰度事件导致起播
         * 则需要清理掉 isPreviewEnd 标志让 PREVIEW_END 事件重新抛出
         */
        this.onVideoPlaying = function (_a) {
            var data = _a.data;
            if (!!data.isFirst) {
                // 直播试看，在开播以后才开始计算试看时长
                _this.previewStartTimeOnLive = +new Date();
            }
            if (_this.isPreviewEnd) {
                _this.isPreviewEnd = false;
                if (!_this.ctrlPlugin)
                    return;
                _this.restoreCtrlBarAction();
            }
        };
        /** TIME_UPDATE 事件回调，检查试看时长并在时长结束时终止 */
        this.onVideoTimeUpdate = function (_a) {
            var playtime = _a.data.playtime;
            var isPreviewOver = false;
            if (_this.isVod) {
                isPreviewOver = _this.checkPreviewOverOnVodMode(playtime);
            }
            else {
                isPreviewOver = _this.checkPreviewOverOnLiveMode();
            }
            if (isPreviewOver) {
                _this.isPreviewEnd = true;
                _this.player.emit(SUPER_EVENTS.PREVIEW_END, {
                    previewDuration: _this.previewDuration,
                    previewRemainCount: _this.previewRemainCount,
                });
            }
        };
        /** 每次播到结束，清理掉设置的试看时间，防止播完一个 vid，再去播 URL 时仍然保有试看 */
        this.onPlaySessionEnd = function () {
            var _a;
            if (_this.previewDuration !== NO_PREVIEW_FLAG) {
                (_a = _this.player.tipsPlugin) === null || _a === void 0 ? void 0 : _a.hide();
            }
            _this.previewDuration = NO_PREVIEW_FLAG;
            _this.previewStartTimeOnLive = 0;
            _this.previewStartPosition = 0;
            if (!_this.ctrlPlugin)
                return;
            _this.setCtrlMaxPercent(1);
            _this.restoreCtrlBarAction();
        };
        /**
         * 暂停时，设置控制栏播放按钮状态
         * 如果在 TimeUpdate 设置，则会被控制栏监听 pause 事件覆盖掉不生效
         */
        this.onVideoPause = function () {
            if (!_this.isPreviewEnd)
                return;
            _this.setCtrlPlayBtnStatus(PlayBtnStatus.REPLAY);
        };
        this.setPreviewListener(true);
    }
    PreviewLogic.prototype.destroy = function () {
        this.setPreviewListener(false);
        this.player = null;
    };
    /** 设置试看监听器，监听 TIME_UPDATE 事件*/
    PreviewLogic.prototype.setPreviewListener = function (isEnable) {
        var evtBinder = isEnable
            ? this.player.on.bind(this.player)
            : this.player.off.bind(this.player);
        evtBinder(H5_PLAY_EVENT.PLAY_SESSION_START, this.onVideoSessionStart);
        evtBinder(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, this.onVideoReqInfoEnd);
        evtBinder(H5_PLAY_EVENT.VIDEO_PLAYING, this.onVideoPlaying);
        evtBinder(H5_PLAY_EVENT.VIDEO_TIMEUPDATE, this.onVideoTimeUpdate);
        evtBinder(H5_PLAY_EVENT.VIDEO_PAUSE, this.onVideoPause);
        evtBinder(H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd);
    };
    /**
    * 检查点播试看是否结束
    * @param playtime 播放时间点
    * @returns 是否结束
    */
    PreviewLogic.prototype.checkPreviewOverOnVodMode = function (playtime) {
        var _this = this;
        if (this.previewDuration === NO_PREVIEW_FLAG
            || (playtime < (this.previewStartPosition + this.previewDuration) // 试看结束位置
                && playtime >= this.previewStartPosition) // 试看开始位置
            || this.isPreviewEnd)
            return false;
        if (uaTool.mobile) {
            setTimeout(function () {
                _this.player.corePlayer.stop(SUPER_END_STATE.PREVIEW);
            });
        }
        else {
            this.player.pause();
            this.disableCtrlAction();
        }
        return true;
    };
    /**
     * 检查直播试看是否结束。直播的试看用倒计时的方式，跟点播不同。
     */
    PreviewLogic.prototype.checkPreviewOverOnLiveMode = function () {
        var _this = this;
        if (this.previewDuration === NO_PREVIEW_FLAG
            || this.previewStartTimeOnLive <= 0
            || this.isPreviewEnd
            || +new Date() - this.previewStartTimeOnLive <= this.previewDuration * 1000) {
            return false;
        }
        setTimeout(function () {
            _this.player.corePlayer.stop(SUPER_END_STATE.PREVIEW);
        });
        return true;
    };
    /** 设置控制栏播放按钮状态 */
    PreviewLogic.prototype.setCtrlPlayBtnStatus = function (status) {
        var _a, _b;
        var PlayBtn = (_b = (_a = this.ctrlPlugin) === null || _a === void 0 ? void 0 : _a.instances) === null || _b === void 0 ? void 0 : _b.PlayBtn;
        if (!PlayBtn)
            return;
        PlayBtn.el.dataset.status = status;
    };
    /** 设置控制栏进度条最大进度值，范围 0～1，清空则设置为 1 */
    PreviewLogic.prototype.setCtrlMaxPercent = function (percentage) {
        var _a, _b;
        if (percentage === void 0) { percentage = 1; }
        var Progress = (_b = (_a = this.ctrlPlugin) === null || _a === void 0 ? void 0 : _a.instances) === null || _b === void 0 ? void 0 : _b.Progress;
        if (!Progress)
            return;
        Progress.maxPercent = percentage;
    };
    /** 当 Web 端试看结束导致暂停后，禁用掉控制栏的一些操作 */
    PreviewLogic.prototype.disableCtrlAction = function () {
        if (!this.ctrlPlugin)
            return;
        // 先存储，方便恢复
        this.lastHotKeysDisabled = this.ctrlPlugin.getIsHotKeysDisabled();
        this.lastCtrlShowDisabled = this.ctrlShow.shadowClickDisabled;
        this.ctrlShow.shadowClickDisabled = true;
        this.ctrlPlugin.setHotKeysDisable(true);
    };
    /** 恢复控制栏快捷操作 */
    PreviewLogic.prototype.restoreCtrlBarAction = function () {
        if (!this.ctrlPlugin)
            return;
        this.ctrlPlugin.setHotKeysDisable(this.lastHotKeysDisabled);
        this.ctrlShow.shadowClickDisabled = this.lastCtrlShowDisabled;
    };
    /** 展示左下角试看 xx 分钟 Tips */
    PreviewLogic.prototype.showTips = function () {
        var _a;
        var isOfficialScenes = getIsOfficialScenes();
        if (!isOfficialScenes) {
            var timeStr = commonTool.formatPlayTime(this.previewDuration);
            var pageLink = getTxVideoPageURLByVid(this.player.vid, '0');
            (_a = this.player.tipsPlugin) === null || _a === void 0 ? void 0 : _a.show({
                text: t(i18nConfig.superPlayer.PREVIEW_TIPS, timeStr, pageLink),
                time: -1,
            });
        }
    };
    Object.defineProperty(PreviewLogic.prototype, "isVod", {
        get: function () {
            return this.player.config.type === PLAY_MODE.VOD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewLogic.prototype, "ctrlShow", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.ctrlPlugin) === null || _a === void 0 ? void 0 : _a.instances) === null || _b === void 0 ? void 0 : _b.CtrlShow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewLogic.prototype, "ctrlPlugin", {
        get: function () {
            return this.player.plugins[CtrlbarPluginName];
        },
        enumerable: false,
        configurable: true
    });
    return PreviewLogic;
}());
/* 没有试看 */
var NO_PREVIEW_FLAG = 0;

/** 腾讯视频目前的所有清晰度名称 */
var FORMAT;
(function (FORMAT) {
    /** 标清（约270p） */
    FORMAT["SD"] = "sd";
    /** 高清（约480p） */
    FORMAT["HD"] = "hd";
    /** 超清（约720p） */
    FORMAT["SHD"] = "shd";
    /** 蓝光 */
    FORMAT["FHD"] = "fhd";
    /** 4k */
    FORMAT["UHD"] = "uhd";
    /** 杜比视界 */
    FORMAT["DOLBY"] = "dolby";
    /** 臻彩视界 */
    FORMAT["HDR10"] = "hdr10";
    /** 臻彩视听 */
    FORMAT["SFR_HDR"] = "sfr_hdr";
})(FORMAT || (FORMAT = {}));
/**
 * 请求腾讯视频点播的流类型（dtype字段）
 */
var REQ_VOD_STREAM_TYPE;
(function (REQ_VOD_STREAM_TYPE) {
    REQ_VOD_STREAM_TYPE[REQ_VOD_STREAM_TYPE["mp4"] = 1] = "mp4";
    REQ_VOD_STREAM_TYPE[REQ_VOD_STREAM_TYPE["hls"] = 3] = "hls";
})(REQ_VOD_STREAM_TYPE || (REQ_VOD_STREAM_TYPE = {}));

var SuperBaseCheck = /** @class */ (function (_super) {
    __extends(SuperBaseCheck, _super);
    function SuperBaseCheck(player) {
        var _this = _super.call(this, player) || this;
        _this.isRetryedInSession = false;
        _this.superPlayer = player;
        return _this;
    }
    SuperBaseCheck.prototype.onSessionStart = function () {
        this.isRetryedInSession = false;
    };
    /**
     * @param videoInfo 播放信息
     * @param degradeOpts 降级配置，如果为空则不降级
     * @returns
     */
    SuperBaseCheck.prototype.getRetryConfig = function (videoInfo, degradeOpts) {
        var result = _super.prototype.getRetryConfig.call(this, videoInfo);
        var _a = degradeOpts || {}, _b = _a.degradeCodecExpireTime, degradeCodecExpireTime = _b === void 0 ? 0 : _b, _c = _a.degradeReason, degradeReason = _c === void 0 ? DEGRADE_CODEC_REASON.UNKNOWN : _c;
        if (result && degradeReason !== DEGRADE_CODEC_REASON.UNKNOWN && this.canDegradeCodecDefn()) {
            // 不播放hevc啦
            result.updatePlayParam.videoReqInfoParam.hevclv = HEVC_LV_VALUE.NOT_SPT;
            result.updatePlayParam.videoReqInfoParam.spav1 = 0;
        }
        else {
            // 条件不通过，也不会降级
            degradeCodecExpireTime = 0;
            degradeReason = DEGRADE_CODEC_REASON.UNKNOWN;
        }
        return __assign$1(__assign$1({}, result), { degradeCodecExpireTime: degradeCodecExpireTime, degradeReason: degradeReason });
    };
    /**
     * 是否可以降级播放。因为腾讯视频4k、hdr等高品质清晰度都为hevc编码，h.264没有对应清晰度，因此不能降级播放。
     * @param defn 当前播放的清晰度名称
     * @returns 是否可降级播放
     */
    SuperBaseCheck.prototype.canDegradeCodecDefn = function (defn) {
        if (!defn) {
            defn = this.superPlayer.getCommonKv(COMMON_DATA_KEY.currentDefn);
        }
        return [FORMAT.SD, FORMAT.HD, FORMAT.SHD, FORMAT.FHD].indexOf(defn) !== -1;
    };
    return SuperBaseCheck;
}(BaseCheck));

/**
 * 检查渲染性能，当渲染性能低于配置的阀值时，需要重试播放。
 */
var CheckFrameDropRate = /** @class */ (function (_super) {
    __extends(CheckFrameDropRate, _super);
    function CheckFrameDropRate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckFrameDropRate;
        _this.checkEvt = PLAY_EVENT.TIME_UPDATE;
        _this.intervalFrameDroppedArr = [];
        return _this;
    }
    CheckFrameDropRate.prototype.check = function (evt) {
        if (this.needIgnore(evt)) {
            return null;
        }
        if (this.needIgnoreBecausePlayTimeCloseToBuffer()) {
            return null;
        }
        if (this.checkFrameDrop()) {
            return this.getRetryConfig(evt.data.videoInfo, {
                degradeCodecExpireTime: this.superPlayer.config.maxDegradeCodecExpireTime,
                degradeReason: DEGRADE_CODEC_REASON.FRAME_DROP,
            });
        }
        return null;
    };
    CheckFrameDropRate.prototype.needIgnore = function (evt) {
        var _a;
        var videoInfo = evt.data.videoInfo;
        if (!this.superPlayer.config.enableDegradeOnLowPerformance
            || (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.currentVideoInfo))
            || videoInfo.config.vcodec === CODEC.H264 // 播放h.264时不检查
            || this.player.kernelName === KERNEL_NAME.WASM // wasm内核播放时由render-performance-checker检查
            || !this.canDegradeCodecDefn() // 4k、hdr这种清晰度，即使有性能问题也没法降级
        ) {
            return true;
        }
        if (this.isRetryedInSession) {
            // 性能问题导致的重试，在session内只能重试一次，并且后面就直接忽略了，不会终止播放
            return true;
        }
        return false;
    };
    /**
     * 播放时间非常靠近某个缓冲段的结束时，忽略帧率检测
     * 这个原因是发现chrome浏览器在hls内核播放时，如果出现缓冲，存在音频比视频缓冲更长，导致卡住时候声音在播画面卡死。例如视频缓冲到52秒，
     * 音频缓冲到54秒，当前播放时间是54秒。52->54秒之间播的时候，100%丢帧
     */
    CheckFrameDropRate.prototype.needIgnoreBecausePlayTimeCloseToBuffer = function () {
        var _a = this.player, playtime = _a.playtime, videoBuffered = _a.videoBuffered;
        for (var i = 0; i < videoBuffered.length; i++) {
            if (Math.abs(videoBuffered[i].end - playtime) < PLAY_TIME_2_BUFFER_MIN_GAP) {
                return true;
            }
        }
        return false;
    };
    CheckFrameDropRate.prototype.checkFrameDrop = function () {
        var _a;
        var maxFrameDropRate = this.superPlayer.config.maxFrameDropRate;
        var _b = (((_a = this.player.currentVideoInfo) === null || _a === void 0 ? void 0 : _a.qualityInfo) || {}).intervalFrameDropped, intervalFrameDropped = _b === void 0 ? 0 : _b;
        this.intervalFrameDroppedArr.push(intervalFrameDropped);
        if (this.intervalFrameDroppedArr.length >= DROP_FRAME_COUNT) {
            var avgFrameDropped = this.intervalFrameDroppedArr.reduce(function (prev, curr) { return prev + curr; }) / DROP_FRAME_COUNT;
            var intervalFrameDroppedArrForLog = [].concat(this.intervalFrameDroppedArr);
            // 清空
            this.intervalFrameDroppedArr.length = 0;
            // 丢帧率超过阀值降级
            if (avgFrameDropped >= maxFrameDropRate) {
                this.logger.log("dropframe rate ".concat(avgFrameDropped, " is more than ").concat(maxFrameDropRate, "\n        intervalFrameDroppedArrForLog=").concat(intervalFrameDroppedArrForLog));
                this.isRetryedInSession = true;
                return true;
            }
        }
        return false;
    };
    return CheckFrameDropRate;
}(SuperBaseCheck));

/**
 * 在播放非h.264编码时，出现原生播放的解码错误、不支持该音视频的错误，降级到h.264
 */
var CheckNoH264Error = /** @class */ (function (_super) {
    __extends(CheckNoH264Error, _super);
    function CheckNoH264Error() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckNoH264Error;
        _this.checkEvt = PLAY_EVENT.ERROR;
        return _this;
    }
    CheckNoH264Error.prototype.check = function (evt) {
        var _a, _b;
        var videoInfo = evt.data.videoInfo;
        var error = videoInfo.error;
        var enableDegradeOnLowPerformance = this.superPlayer.config.enableDegradeOnLowPerformance;
        if (this.isRetryedInSession) {
            // 一个session内只能降级一次
            return null;
        }
        if (!videoInfo.config || videoInfo.config.vcodec === CODEC.H264 || !enableDegradeOnLowPerformance) {
            // 类似找不到内核之类的报错（没有走到创建kernel），可能没有urlConfig
            return null;
        }
        var code = (_b = (_a = error.code) === null || _a === void 0 ? void 0 : _a.split) === null || _b === void 0 ? void 0 : _b.call(_a, '.')[0];
        if (code !== ERROR_CODE.MEDIA_ERR_DECODE && code !== ERROR_CODE.MEDIA_ERR_SRC_NOT_SUPPORTED) {
            return null;
        }
        this.isRetryedInSession = true;
        return this.getRetryConfig(videoInfo, {
            degradeCodecExpireTime: 0,
            degradeReason: DEGRADE_CODEC_REASON.ORG_SPT_ERR,
        });
    };
    return CheckNoH264Error;
}(SuperBaseCheck));

var SuperCheckNormalError = /** @class */ (function (_super) {
    __extends(SuperCheckNormalError, _super);
    function SuperCheckNormalError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuperCheckNormalError.prototype.getRetryConfig = function (videoInfo) {
        var result = _super.prototype.getRetryConfig.call(this, videoInfo);
        var maxRetryGetinfoTimes = this.player.config.maxRetryGetinfoTimes;
        var degradeReason = result.degradeReason || DEGRADE_CODEC_REASON.UNKNOWN;
        if (this.retryTimes === maxRetryGetinfoTimes) {
            // 最后一次重试，降级
            this.logger.log("degrade retry on last time[".concat(this.retryTimes, "/").concat(maxRetryGetinfoTimes, "]"), result);
            result.updatePlayParam.videoReqInfoParam.hevclv = HEVC_LV_VALUE.NOT_SPT;
            result.updatePlayParam.videoReqInfoParam.spav1 = 0;
            degradeReason = DEGRADE_CODEC_REASON.LAST;
        }
        return __assign$1(__assign$1({}, result), { degradeCodecExpireTime: 0, degradeReason: degradeReason });
    };
    return SuperCheckNormalError;
}(CheckNormalError));

/**
 * 如果是非wasm内核播放hevc视频出错（即浏览器原生支持hevc的播放），尝试使用wasm内核播放
 */
var CheckOriginPlayHevcError = /** @class */ (function (_super) {
    __extends(CheckOriginPlayHevcError, _super);
    function CheckOriginPlayHevcError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckOriginPlayHevcError;
        _this.checkEvt = PLAY_EVENT.ERROR;
        return _this;
    }
    CheckOriginPlayHevcError.prototype.check = function (evt) {
        var _a;
        var videoInfo = evt.data.videoInfo;
        var playtime = videoInfo.playtime, error = videoInfo.error;
        if (this.isRetryedInSession) {
            return null;
        }
        // 这里做一下兼容性的处理，高版本的core会抛出带有子码的错误码，但是这里只关心主错误码
        var code = (_a = error === null || error === void 0 ? void 0 : error.code) === null || _a === void 0 ? void 0 : _a.split('.')[0];
        if (!this.superPlayer.config.retryHevcByWasmIfOriginErr
            || !videoInfo.config
            || videoInfo.config.vcodec !== CODEC.H265
            || this.player.kernelName === KERNEL_NAME.WASM
            || (code !== ERROR_CODE.MEDIA_ERR_DECODE && code !== ERROR_CODE.MEDIA_ERR_SRC_NOT_SUPPORTED)) {
            return null;
        }
        this.isRetryedInSession = true;
        return {
            error: error,
            updatePlayParam: {
                videoLoadParam: {
                    startTime: playtime,
                    kernelName: KERNEL_NAME.WASM,
                },
            },
        };
    };
    return CheckOriginPlayHevcError;
}(SuperBaseCheck));

/**
 * 检查渲染性能，当渲染性能低于配置的阀值时，需要重试播放。
 */
var CheckRenderPerformance = /** @class */ (function (_super) {
    __extends(CheckRenderPerformance, _super);
    function CheckRenderPerformance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckRenderPerformance;
        _this.checkEvt = PLAY_EVENT.VIDEO_FRAME_RENDER;
        _this.lowRenderFrameCount = 0;
        _this.lowRenderFrameTimeCostArr = [];
        _this.renderTotalCount = 0;
        return _this;
    }
    CheckRenderPerformance.prototype.onSessionStart = function () {
        this.lowRenderFrameCount = 0;
        this.renderTotalCount = 0;
        _super.prototype.onSessionStart.call(this);
    };
    CheckRenderPerformance.prototype.check = function (evt) {
        var _a = this.superPlayer.config, minRenderFrameRate = _a.minRenderFrameRate, maxLowRenderFrameRate = _a.maxLowRenderFrameRate, enableDegradeOnLowPerformance = _a.enableDegradeOnLowPerformance, maxDegradeCodecExpireTime = _a.maxDegradeCodecExpireTime;
        var videoInfo = evt.data.videoInfo;
        var isValidConfig = minRenderFrameRate < 1
            && minRenderFrameRate > 0
            && maxLowRenderFrameRate < 1
            && maxLowRenderFrameRate > 0;
        if (!enableDegradeOnLowPerformance
            || !isValidConfig // 配置信息不正确
            || this.player.kernelName !== KERNEL_NAME.WASM
            || !this.canDegradeCodecDefn() // 4k、hdr这种清晰度，即使有性能问题也没法降级
        ) {
            return null;
        }
        var videoFrameRate = (this.player.currentVideoInfo || {}).videoFrameRate;
        if (!videoFrameRate || videoFrameRate < 0) {
            // 拿不到视频帧率时候也不用检查
            return null;
        }
        if (this.isRetryedInSession) {
            // 性能问题导致的重试，在session内只能重试一次。并且后面就直接忽略了，不会终止播放
            return null;
        }
        // 每帧渲染容忍的最低时长，例如40ms的渲染帧，只执行了30ms，那么代表已经发生丢帧
        var minRenderFrameCostTime = 1000 / videoFrameRate * minRenderFrameRate;
        var renderCostTime = evt.data.renderCostTime;
        // 记录一下帧渲染耗时
        this.lowRenderFrameTimeCostArr.push(renderCostTime);
        if (renderCostTime < minRenderFrameCostTime) {
            // 如果渲染耗时小于最大可容忍的渲染耗时，累加计数器
            this.lowRenderFrameCount++;
        }
        this.renderTotalCount++;
        if (this.renderTotalCount >= 1000) {
            var statsInfo = this.recordStats();
            // 统计达到1000帧时，计算低渲染帧的比例
            var lowRenderFrameRate = this.lowRenderFrameCount / this.renderTotalCount;
            // 统计达到1000帧时，重置累计器
            this.renderTotalCount = 0;
            this.lowRenderFrameCount = 0;
            // 如果低帧率比例超过能容忍的帧最低渲染耗时比例
            if (lowRenderFrameRate > maxLowRenderFrameRate) {
                this.logger.log("low render frame rate ".concat(lowRenderFrameRate, " is more than ").concat(maxLowRenderFrameRate));
                this.writeStats(statsInfo);
                this.isRetryedInSession = true;
                return this.getRetryConfig(videoInfo, {
                    degradeCodecExpireTime: maxDegradeCodecExpireTime,
                    degradeReason: DEGRADE_CODEC_REASON.WASM_RENDER,
                });
            }
        }
        return null;
    };
    /**
     * 写入统计数据便于排查
     */
    CheckRenderPerformance.prototype.recordStats = function () {
        var _a = this.superPlayer.config, minRenderFrameRate = _a.minRenderFrameRate, maxLowRenderFrameRate = _a.maxLowRenderFrameRate;
        var statisticsInfo = {
            lowRenderFrameTimeCostArr: this.lowRenderFrameTimeCostArr.slice(-200),
            lowRenderFrameCount: this.lowRenderFrameCount,
            renderTotalCount: this.renderTotalCount,
            maxLowRenderFrameRate: maxLowRenderFrameRate,
            minRenderFrameRate: minRenderFrameRate,
        };
        this.lowRenderFrameTimeCostArr.length = 0;
        return statisticsInfo;
    };
    CheckRenderPerformance.prototype.writeStats = function (statsInfo) {
        // 这个ls的写入数据纯为了排查问题而记录在用户本地
        try {
            var statsInfoStr = JSON.stringify(statsInfo);
            lsTool.setData(LOCAL_STORAGE_KEY.RENDER_STATS_INFO, statsInfoStr);
        }
        catch (e) { }
    };
    return CheckRenderPerformance;
}(SuperBaseCheck));

/**
 * safari浏览器使用hls内核播放分辨率有变化的视频，会报错，回滚到原生播放
 * （测试视频https://thumbplayer-76307.gzc.vod.tencent-cloud.com/testvideo/hls/live-to-vod-safari-issue/f320092.ts.m3u8）
 */
var CheckSafariHlsError = /** @class */ (function (_super) {
    __extends(CheckSafariHlsError, _super);
    function CheckSafariHlsError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckSafariHlsError;
        _this.checkEvt = PLAY_EVENT.ERROR;
        return _this;
    }
    CheckSafariHlsError.prototype.check = function (evt) {
        var _a, _b;
        var videoInfo = evt.data.videoInfo;
        var playtime = videoInfo.playtime, error = videoInfo.error;
        if (this.isRetryedInSession) {
            return null;
        }
        // 这里做一下兼容性的处理，高版本的core会抛出带有子码的错误码，但是这里只关心主错误码
        var code = (_a = error === null || error === void 0 ? void 0 : error.code) === null || _a === void 0 ? void 0 : _a.split('.')[0];
        // 使用safari浏览器，hls内核，播放h.264视频，出现解码错误，需要判断
        var needCheck = uaTool.browser.safari
            && this.player.kernelName === KERNEL_NAME.HLS_JS
            && ((_b = videoInfo.config) === null || _b === void 0 ? void 0 : _b.vcodec) === CODEC.H264
            && code === ERROR_CODE.MEDIA_ERR_DECODE;
        if (!needCheck) {
            return null;
        }
        this.isRetryedInSession = true;
        return {
            error: error,
            updatePlayParam: {
                videoLoadParam: {
                    startTime: playtime,
                    // 强行回滚到原生播放
                    kernelName: KERNEL_NAME.ORIGIN,
                },
            },
        };
    };
    return CheckSafariHlsError;
}(SuperBaseCheck));

/**
 * 检查wasm内核错误码，例如wasm内核抛出不支持，需要降级重试
 */
var CheckWasmError = /** @class */ (function (_super) {
    __extends(CheckWasmError, _super);
    function CheckWasmError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckWasmError;
        _this.checkEvt = PLAY_EVENT.ERROR;
        return _this;
    }
    CheckWasmError.prototype.check = function (evt) {
        var videoInfo = evt.data.videoInfo;
        var error = videoInfo.error;
        var code = error.code;
        if (this.isRetryedInSession) {
            return null;
        }
        // 这个是wasm-kernel里面的错误码，拿不到，所以在这里枚举下
        var WASM_NOT_SPT_ERROR = '70060003';
        if (!this.superPlayer.config.enableDegradeOnLowPerformance) {
            return null;
        }
        if (code !== WASM_NOT_SPT_ERROR) {
            // TODO：不是很确定wasm环境不支持，是不是就永久关闭wasm内核，因为wasm不支持的条件中，既有永久不支持的（例如sab,webassembly），还有
            // 动态不支持的（例如webgl，浏览器会有突然不支持webgl的case）
            // this.wirteDegradeExpireTimeToLocal();
            return null;
        }
        this.isRetryedInSession = true;
        return this.getRetryConfig(videoInfo, {
            degradeCodecExpireTime: 0,
            degradeReason: DEGRADE_CODEC_REASON.WASM_SPT_ERR,
        });
    };
    return CheckWasmError;
}(SuperBaseCheck));

/**
 * 降级编码播放的原因
 */
var DEGRADE_CODEC_REASON;
(function (DEGRADE_CODEC_REASON) {
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["UNKNOWN"] = 0] = "UNKNOWN";
    /** 丢帧 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["FRAME_DROP"] = 1] = "FRAME_DROP";
    /** wasm渲染性能 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["WASM_RENDER"] = 2] = "WASM_RENDER";
    /** wasm不支持 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["WASM_SPT_ERR"] = 3] = "WASM_SPT_ERR";
    /** 11102/11103报错 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["ORG_SPT_ERR"] = 4] = "ORG_SPT_ERR";
    /** 用户触发 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["USER"] = 5] = "USER";
    /** 最后一次兜底重试 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["LAST"] = 6] = "LAST";
})(DEGRADE_CODEC_REASON || (DEGRADE_CODEC_REASON = {}));
/** 需要按多少帧来计算平均丢帧 */
var DROP_FRAME_COUNT = 60;
/** 播放时间点距离缓冲区结束的最近值 */
var PLAY_TIME_2_BUFFER_MIN_GAP = 3;
var RetryNames = {
    CheckFrameDropRate: 'CheckFrameDropRate',
    CheckNoH264Error: 'CheckNoH264Error',
    CheckOriginPlayHevcError: 'CheckOriginPlayHevcError',
    CheckRenderPerformance: 'CheckRenderPerformance',
    CheckSafariHlsError: 'CheckSafariHlsError',
    CheckWasmError: 'CheckWasmError',
};
/**
 * 重试的checker数组
 * 注意：判断走哪个重试策略，是有优先级的，因此数组有顺序要求
 */
var RetryClasses = [
    CheckFrameDropRate,
    CheckRenderPerformance,
    CheckWasmError,
    CheckOriginPlayHevcError,
    CheckSafariHlsError,
    CheckNoH264Error,
    SuperCheckNormalError,
];

/**
 * 写入localstorage当前降级时间戳，一定时间内不会再次请求非h.264播放
 */
function writeDegradeCodecToLocal(degradeExpireTime, degradeReason, extra) {
    var dataStr = JSON.stringify(__assign$1({ time: Date.now(), degradeExpireTime: degradeExpireTime, degradeReason: degradeReason }, extra));
    lsTool.setData(LOCAL_STORAGE_KEY.DEGRADE_CODEC_TIME, dataStr);
}
/**
 * 读取当前缓存中的降级信息
 * @returns 是否需要降级以及被降级原因
 */
function readDegradeCodecFromLocal() {
    var time = NaN;
    var degradeExpireTime = NaN;
    var degradeReason = DEGRADE_CODEC_REASON.UNKNOWN;
    try {
        var dataStr = lsTool.getData(LOCAL_STORAGE_KEY.DEGRADE_CODEC_TIME);
        var data = JSON.parse(dataStr || '{}');
        time = +data.time;
        degradeExpireTime = +data.degradeExpireTime;
        degradeReason = data.degradeReason;
    }
    catch (e) {
    }
    if (Number.isNaN(time) || Number.isNaN(degradeExpireTime) || Date.now() >= time + degradeExpireTime) {
        // 没有过期时间，或者当前时间已经超过过期时间，不需要降级
        return { needDegrade: false };
    }
    return { needDegrade: true, degradeReason: degradeReason };
}

/** 腾讯视频点播播放时默认的平台号判断 */
function getDefaultVodPlatform() {
    if (uaTool.mobile) {
        return '11001';
    }
    // 是否属于腾讯视频站内播放
    var inSite = isOfficialSite();
    return inSite ? BUILDIN_PLATFORM.VOD_INSITE : BUILDIN_PLATFORM.VOD_OUTSITE;
}
/**
 * 判断是否是站内域名（即腾讯视频域名，根据顶级域名判断）。
 */
function isOfficialSite() {
    var topUrl = urlTool.getTopFrameUrl();
    var domain = urlTool.getDomainOfURL(topUrl);
    var officialSites = [
        'v.qq.com',
        'film.qq.com',
    ];
    return officialSites.includes(domain);
}
/** 腾讯视频点播播放时的默认sdtfrom */
function getDefautVodSdtfrom(platform) {
    if (platform === '11001') {
        if (uaTool.os.iphone || uaTool.os.ipod) {
            return 'v3010';
        }
        if (uaTool.os.ipad) {
            return 'v4010';
        }
        if (uaTool.os.tablet) {
            return 'v6010';
        }
        if (uaTool.os.android) {
            return 'v5010';
        }
        if (uaTool.browser.IEMobile) {
            return 'v7010';
        }
    }
    var map = {
        70201: 'v1104', // 外站windows
    };
    return map[platform] || 'v1010';
}

var VERSION$1 = getEnvVals().VERSION;
/** 默认生成的腾讯视频点播平台号 */
var defaultVodPlatform = getDefaultVodPlatform();
/** 默认生成的腾讯视频点播sdtfrom字段 */
var defautVodSdtfrom = getDefautVodSdtfrom(defaultVodPlatform);
var defaultVodBusinessConfig = {
    platform: defaultVodPlatform,
    sdtfrom: defautVodSdtfrom,
};
var defaultSuperConfig = {
    enableDegradeOnLowPerformance: true,
    maxDegradeCodecExpireTime: 0.5 * 24 * 3600 * 1000,
    // 降级播放的默认配置
    minRenderFrameRate: 0.8,
    maxLowRenderFrameRate: 0.3,
    maxFrameDropRate: 0.2,
    // 暂时默认开启
    enableTVK: true,
    enableP2P: true,
    proxyHttpPath: getTestProxyHttpPath(),
};
/**
 * 腾讯视频直播的平台号和sdtfrom默认写死
 * TODO：貌似体育的平台号是40201？？
 */
var defaultLiveBusinessConfig = {
    platform: BUILDIN_PLATFORM.LIVE_INSITE,
    sdtfrom: BUILDIN_PLATFORM.LIVE_INSITE,
};
function defaultGetinfoConfig(isVod, platform) {
    var whiteList = [BUILDIN_PLATFORM.VOD_INSITE];
    // 1. 如果是点播，判断平台号，只在 v 站上默认用 ckey9
    if (isVod && whiteList.includes(platform)) {
        return { ckeyVer: CKEY_VRE.CKEY_9 };
    }
    // 2. 如果是直播 / 或者点播未命中平台号，则不返回任何默认配置，完全由 new SuperPlayer 时传入的配置指定
    return {};
}
function getBuiltInPlugins(type, config) {
    var _a;
    var _b;
    if (type === void 0) { type = PLAY_MODE.VOD; }
    var _c = config.removeComponents, removeComponents = _c === void 0 ? [] : _c;
    var disablePoster = removeComponents.includes(PosterPluginName) || !!config.disablePoster;
    var disableCtrlbar = removeComponents.includes(CtrlbarPluginName) || !!config.disableCtrlbar;
    var disableErrorPage = removeComponents.includes(ErrorPagePluginName) || !!config.disableErrorPage;
    var disableTips = removeComponents.includes(TipsPluginName) || !!config.disableTips;
    var disableLoading = removeComponents.includes(UILoadingPlugin.pluginName) || !!config.disableLoading;
    var disableCtxMenu = removeComponents.includes(UIContextMenuPluginName) || !!config.disableCtxMenu;
    var disableWatermark = removeComponents.includes(WatermarkPluginName) || !!config.disableWatermark;
    var disableInfoPanel = removeComponents.includes(InfoPanelPluginName);
    var pluginMap = (_a = {},
        _a[PosterPluginName] = { isEnabled: !disablePoster, config: config.poster },
        _a[CtrlbarPluginName] = { isEnabled: !disableCtrlbar },
        _a[ErrorPagePluginName] = { isEnabled: !disableErrorPage, config: { showOnError: true } },
        _a[TipsPluginName] = { isEnabled: !disableTips },
        _a[UILoadingPlugin.pluginName] = { isEnabled: !disableLoading },
        _a[UIContextMenuPluginName] = {
            // 移动端不需要右键菜单插件
            isEnabled: !isMobile && !disableCtxMenu,
            config: { menus: [{ role: 'version', label: VERSION$1 || '1.3.0' }] },
        },
        _a[InfoPanelPluginName] = { isEnabled: !disableInfoPanel, config: { defaultInfo: true } },
        _a[LivepollPlugin.pluginName] = {
            isEnabled: type === PLAY_MODE.LIVE,
            config: { livepid: (_b = config.livepollConfig) === null || _b === void 0 ? void 0 : _b.livepid },
        },
        _a[WatermarkPluginName] = { isEnabled: !disableWatermark },
        _a);
    var plugins = [];
    Object.keys(pluginMap).forEach(function (pluginName) {
        var _a = pluginMap[pluginName], isEnabled = _a.isEnabled, config = _a.config;
        if (isEnabled) {
            plugins.push(!config ? pluginName : [pluginName, config]);
        }
    });
    return plugins;
}
function getSuperConfig(config) {
    var _a, _b, _c;
    var _d = config.plugins, plugins = _d === void 0 ? [] : _d, _e = config.mode, mode = _e === void 0 ? PLAY_MODE.VOD : _e, _f = config.businessConfig, businessConfig = _f === void 0 ? {} : _f, _g = config.coreConfig, coreConfig = _g === void 0 ? {} : _g, _h = config.pluginConfig, pluginConfig = _h === void 0 ? {} : _h, _j = config.dynamicConfig, dynamicConfig = _j === void 0 ? {} : _j;
    config.type = (_a = config.type) !== null && _a !== void 0 ? _a : mode;
    var type = config.type, lazyInitPlugins = config.lazyInitPlugins;
    var defaultBusinessConf = type === PLAY_MODE.VOD ? defaultVodBusinessConfig : defaultLiveBusinessConfig;
    var buzConfig = __assign$1(__assign$1({}, defaultBusinessConf), businessConfig);
    var builtInPlugins = getBuiltInPlugins(type, config);
    var playerPlugins = __spreadArray(__spreadArray([], builtInPlugins, true), plugins, true);
    var platform = buzConfig.platform;
    var superPlayerConfig = __assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1({}, defaultSuperConfig), { supportedPaidFormat: isOfficialSite()
            ? [PAID_FORMAT.FHD, PAID_FORMAT.DOLBY, PAID_FORMAT.SFR_HDR, PAID_FORMAT.UHD] : [], logLevel: getLogLevelFromUrl(), 
        // 这里解构顺序是为了让config中未拍平的配置优先级高于pluginConfig和coreConfig
        videoElementConfig: {
            playsinline: true,
        }, 
        // 使用两个videoNode目前只为了切换清晰度不黑屏。但在移动端使用两个video标签存在一些兼容性问题，因此在移动端默认用1个video标签。
        // 目前发现移动端用多个video标签的时候可能存在以下问题：
        // 1. 无法同时播放
        // 2. ios15.0黑屏
        // 3. 微信浏览器自动播放时，点击都无法起播
        maxVideoNodeCount: (isMobile || type === PLAY_MODE.LIVE) ? 1 : 2 }), pluginConfig), coreConfig), config), { businessConfig: buzConfig, plugins: playerPlugins, offlineConfig: __assign$1({ platform: platform }, config.offlineConfig), getinfoConfig: __assign$1(__assign$1({}, defaultGetinfoConfig(type === PLAY_MODE.VOD, platform)), config.getinfoConfig), errorPageConfig: __assign$1({ useBrowserTip: isOfficialSite(), useClientBtn: isOfficialSite() }, config.errorPageConfig), ctrlConfig: __assign$1(__assign$1({ disableNextBtn: true, hidePopupOnClick: true }, pluginConfig.ctrlConfig), config.ctrlConfig), infoPanelConfig: __assign$1({ defaultInfo: true }, config.infoPanelConfig), vodQaReporterConfig: __assign$1(__assign$1({}, config === null || config === void 0 ? void 0 : config.vodQaReporterConfig), { paramsKey: __assign$1(__assign$1({}, (_b = pluginConfig.vodQaReporterConfig) === null || _b === void 0 ? void 0 : _b.paramsKey), (_c = config === null || config === void 0 ? void 0 : config.vodQaReporterConfig) === null || _c === void 0 ? void 0 : _c.paramsKey) }) });
    if (config.isPrivateDeployment) {
        superPlayerConfig.enableTVK = false;
    }
    var lazyPlugins = [];
    var result = {
        superPlayerConfig: mergeDynamicConfig(superPlayerConfig, getLocalDynamicConfig() || dynamicConfig),
        lazyPlugins: lazyPlugins,
    };
    if (!lazyInitPlugins)
        return result;
    result.superPlayerConfig.plugins = result.superPlayerConfig.plugins.filter(function (plugin) {
        var pluginName = typeof plugin === 'string' ? plugin : plugin[0];
        if (LAZY_PLUGINS.includes(pluginName)) {
            lazyPlugins.push(plugin);
            return false;
        }
        return true;
    });
    return result;
}
function getAdInitConfig(config) {
    var _a;
    var _b = config.adKernelName, adKernelName = _b === void 0 ? KERNEL_NAME.DEMUX_2_FMP4 : _b, adInitConfig = config.adInitConfig, useSingleVideoElement = config.useSingleVideoElement;
    var hasInstalledDemuxKernel = !!KernelFactory.getKernelByName(KERNEL_NAME.DEMUX_2_FMP4);
    var isUseDemuxKernel = !uaTool.browser.safari
        && hasInstalledDemuxKernel
        && adKernelName === KERNEL_NAME.DEMUX_2_FMP4;
    return __assign$1(__assign$1({}, adInitConfig), { playerData: __assign$1(__assign$1({}, adInitConfig === null || adInitConfig === void 0 ? void 0 : adInitConfig.playerData), { 
            // 移动端默认使用单 video 模式
            playerVideoDom: (useSingleVideoElement !== null && useSingleVideoElement !== void 0 ? useSingleVideoElement : uaTool.mobile) ? (_a = config.videoElements) === null || _a === void 0 ? void 0 : _a[0] : undefined }), isUseDemuxKernel: isUseDemuxKernel, opencache: isUseDemuxKernel });
}
/**
 * 从localstorage中获取动态配置。这个配置信息由播放器的前置脚本从服务器拉取并写入。
 */
function getLocalDynamicConfig() {
    var superPlayerDynamicConfigId = window.SUPER_PLAYER_DYNAMIC_CONFIG_ID;
    if (!superPlayerDynamicConfigId) {
        // 页面没有给全局动态配置id
        return null;
    }
    try {
        var localDataStr = lsTool.getData(LOCAL_STORAGE_KEY.DYNAMIC_CONFIG);
        if (!localDataStr) {
            // 本地没缓存
            return null;
        }
        var localData = JSON.parse(localDataStr);
        var localAppData = localData[superPlayerDynamicConfigId];
        if (!(localAppData === null || localAppData === void 0 ? void 0 : localAppData.app_config) || localAppData.app_config === '{}' || localAppData.app_config === '') {
            // 本地缓存中没有页面指定的id的动态配置信息
            return null;
        }
        var localAppDynamicConfig = JSON.parse(localAppData.app_config);
        return localAppDynamicConfig;
    }
    catch (e) {
    }
    return null;
}
/** 处理dynamicConfig，对象属性合并，其他覆盖 */
function mergeDynamicConfig(config, dynamicConfig) {
    var superConfig = config;
    Object.keys(dynamicConfig).forEach(function (key) {
        var value = superConfig[key];
        if (Object.prototype.toString.call(value) === '[object Object]') {
            superConfig[key] = __assign$1(__assign$1({}, value), dynamicConfig[key]);
        }
        else {
            superConfig[key] = dynamicConfig[key];
        }
    });
    return superConfig;
}

var extInfoCgi = '//h5vv6.video.qq.com/getextinfo';
// 接口文档 http://tapd.oa.com/qqvideo_prj/markdown_wikis/show/#1210114481001152021
function requestVideoExtInfo(options) {
    return __awaiter(this, void 0, void 0, function () {
        var vid, _a, platform, reqParam, reqUrl, res, limit, td, preview, fs;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    vid = options.vid, _a = options.platform, platform = _a === void 0 ? '11001' : _a;
                    reqParam = {
                        vid: vid,
                        platform: platform,
                        h5flag: 1,
                        otype: 'json',
                    };
                    reqUrl = "".concat(extInfoCgi, "?").concat(urlTool.object2string(reqParam, '&'));
                    return [4 /*yield*/, netTool.jsonp(reqUrl)];
                case 1:
                    res = _b.sent();
                    // 接口调用失败
                    if (res.s !== 'o')
                        return [2 /*return*/, null];
                    // 接口调用成功, em 非 0
                    if (res.em && +res.em !== 0)
                        return [2 /*return*/, null];
                    limit = res.limit, td = res.td, preview = res.preview, fs = res.fs;
                    return [2 /*return*/, {
                            duration: +limit === 0 ? +td : +preview,
                            payLimit: +limit,
                            fileSize: fs,
                        }];
            }
        });
    });
}

/** 在 localStorage 中缓存一些起播前置的异步环境变量，用于加速起播 */
var EnvCache = /** @class */ (function () {
    function EnvCache() {
    }
    /** 获取单项配置 */
    EnvCache.get = function (key) {
        var _a;
        return (_a = getEnvData()) === null || _a === void 0 ? void 0 : _a[key];
    };
    /** 全量读取配置，更新配置后再写回 */
    EnvCache.set = function (key, value) {
        var _a;
        var data = (_a = getEnvData()) !== null && _a !== void 0 ? _a : {};
        data[key] = value;
        lsTool.setData(LOCAL_STORAGE_KEY.ENV_CACHE, JSON.stringify(data));
    };
    /** 清除配置缓存 */
    EnvCache.clear = function () {
        lsTool.setData(LOCAL_STORAGE_KEY.ENV_CACHE, '');
    };
    return EnvCache;
}());
var EnvCacheKeys;
(function (EnvCacheKeys) {
    EnvCacheKeys["drm"] = "drm";
    EnvCacheKeys["hdr"] = "hdr";
    /** 是否打开hevc播放（低性能播放被降级后，本地缓存中记录，则永久关闭hevc播放） */
    EnvCacheKeys["enableHevc"] = "enableHevc_20220822";
})(EnvCacheKeys || (EnvCacheKeys = {}));
/** 获取缓存数据 */
function getEnvData() {
    var data = lsTool.getData(LOCAL_STORAGE_KEY.ENV_CACHE);
    if (data === '')
        return;
    try {
        var res = JSON.parse(data);
        if (Object.prototype.toString.call(res) === '[object Object]') {
            return res;
        }
        // 如果缓存中的数据不是对象，则清空缓存
        EnvCache.clear();
    }
    catch (_a) { }
}

/**
 * 判断当前环境是否支持AV1编码并添加相应请求参数。
 */
function sptAV1OnTx() {
    var isChromiumEdge = uaTool.browser.edg && uaTool.browser.chrome;
    if (videoTool.supportAV1()) {
        // chromium edg下调用设备av1解码器需要开启硬件加速
        if (isChromiumEdge && !videoTool.isHardwareAccelerated())
            return null;
        // https://tapd.woa.com/qqvideo_prj/markdown_wikis/show/#1210114481001146481
        // 15表示sd-fhd均支持av1
        return { spav1: 15 };
    }
    return null;
}
/**
 * 获取请求后台hevclv的参数。例如请求直播后台，需要使用hevclv参数指定返回265流。
 * @param playerConfig 播放器配置
 * @param reqParams 本次请求参数
 * @returns 返回为{ hevclv: number }
 */
function getHevcLevelRequestValue(playerConfig, playConfig, reqParams, userCookies) {
    var _a;
    var enableTxHevc = playerConfig.enableTxHevc, supportedPaidFormat = playerConfig.supportedPaidFormat;
    var reqDefn = reqParams.defn;
    if (playConfig.roomid) {
        // 个人直播有概率下发flv流，但是我们的flv内核并未支持hevc格式，因此个人直播关掉hevc支持参数
        return null;
    }
    // 当前原生支持hevc编码
    if (videoTool.supportHevc() // 浏览器原生hevc支持判断
        // 移动端暂不开启
        && !uaTool.mobile
        // 灰度策略
        && hevcCanaryReleaseStrategy(playerConfig, playConfig, reqParams)) {
        if (supportedPaidFormat.indexOf(PAID_FORMAT.UHD) !== -1
            && (uaTool.browser.chrome || uaTool.browser.safari) // 只是灰度条件，后续删除这个条件
        ) {
            // 使用hls内核播放4k视频
            return { hevclv: HEVC_LV_VALUE.UHD };
        }
        return { hevclv: HEVC_LV_VALUE.FHD };
    }
    // 使用wasm内核播放hevc视频
    if (enableTxHevc
        && ((_a = KernelFactory.kernelMap[KERNEL_NAME.WASM]) === null || _a === void 0 ? void 0 : _a.isEnvSupport)
        && sptWasmHevcOnTx()
        // 清晰度条件有两个
        // a) 为undefined时候即没有强制请求某个清晰度，认为是后台自动选择清晰度
        // b) 另外基于当前wasm内核性能的考虑，低清晰度请求hevc播放
        && (typeof reqDefn === 'undefined' || [FORMAT.SD, FORMAT.HD].indexOf(reqDefn) !== -1)) {
        // 播放器配置中默认启用腾讯视频hevc的情况：
        // 如果是请求的自动清晰度或者请求的低码率清晰度，返回hevc-level到高清
        return { hevclv: HEVC_LV_VALUE.HD };
    }
    // 不支持hevc播放
    return null;
}
/**
 * hevc播放灰度配置策略
 */
function hevcCanaryReleaseStrategy(playerConfig, playConfig, reqParams, userCookies) {
    var livepid = playConfig.livepid;
    var _a = playerConfig.enableHevcRateOnPid, enableHevcRateOnPid = _a === void 0 ? 0 : _a, enableHevcPids = playerConfig.enableHevcPids, type = playerConfig.type;
    if (
    // 点播已全量
    type === PLAY_MODE$1.VOD
        // 未配置pid时，直接全量播放hevc
        || !enableHevcPids)
        return true;
    if (!livepid || enableHevcPids.indexOf(livepid) === -1) {
        // 首先播放的pid必须在灰度列表中
        return false;
    }
    var guid = reqParams.guid;
    if (enableHevcRateOnPid <= 0 || enableHevcRateOnPid > 1 || !guid) {
        // 灰度的比例数不合法（比例为0也无需灰度）
        // 或者没有vuserid无法判断是否可以被灰度到
        return false;
    }
    return isCanaryTarget(guid, enableHevcRateOnPid);
}
/**
 * 判断当前是否支持腾讯视频的wasm内核的hevc播放。
 */
function sptWasmHevcOnTx() {
    var isChrome92 = uaTool.browser.chrome && commonTool.compareVersion(uaTool.browser.chrome.version, '92.0') >= 0;
    // 在用户机器本地缓存中是否有开启hevc播放的标识
    var enableHevcFlagInEnvCache = EnvCache.get(EnvCacheKeys.enableHevc);
    if (typeof enableHevcFlagInEnvCache === 'undefined') {
        // 默认是开启的
        enableHevcFlagInEnvCache = 1;
    }
    var enoughCore = navigator.hardwareConcurrency > 8;
    return isChrome92 && enableHevcFlagInEnvCache === 1 && enoughCore;
}
function getCodecParams(playerConfig, playConfig, reqParams, userCookies) {
    var _a;
    // 外部传入的codec类型，例如h.265、h.264等
    var preferCodec = playerConfig.preferCodec;
    var forcePlayCodec = playConfig.playCodec;
    var forceCodecFromUrl = getForceCodecFromUrl();
    if (forceCodecFromUrl) {
        // url上的调试参数直接指定使用哪种编码播放
        forcePlayCodec = +forceCodecFromUrl;
    }
    var res = {};
    // force codec 优先
    // 1. 调用方强制要求播264（不播hevc）
    if (forcePlayCodec === PLAY_CODEC.H264) {
        return {};
    }
    // 2. 调用方强制要求播hevc
    if (forcePlayCodec === PLAY_CODEC.H265) {
        // （这里不需要判断环境是否支持，因为类似监看系统就是强制播hevc，播不了就提示错误，而不是回滚到264播放）
        return { hevclv: HEVC_LV_VALUE.UHD };
    }
    // 3. ls中有缓存不播h.264以外的编码
    var needDegrade = readDegradeCodecFromLocal().needDegrade;
    if (!!needDegrade) {
        return {};
    }
    // 如果用户传入的preferCodec是一个空数组，视为不添加任何除H264外额外的codec播放
    if ((preferCodec === null || preferCodec === void 0 ? void 0 : preferCodec.length) === 0)
        return {};
    /**
     * 是否使用prefer的取值形式
     * 1. 如果使用prefer，则仅返回用户传入的列表中的第一个支持的codec参数
     * 2. 如果不使用prefer，则默认返回所有支持的codec参数
     */
    var usePrefer = !!preferCodec;
    // 默认支持av1，h265
    var codecList = preferCodec || [VIDEO_CODEC.AV1, VIDEO_CODEC.H265];
    // 探测map
    var detectMethods = (_a = {},
        _a[VIDEO_CODEC.AV1] = sptAV1OnTx,
        _a[VIDEO_CODEC.H265] = function () { return getHevcLevelRequestValue(playerConfig, playConfig, reqParams); },
        _a);
    for (var i = 0; i < codecList.length; i++) {
        var codec = codecList[i];
        var detectMethod = detectMethods[codec];
        var codecParams = detectMethod === null || detectMethod === void 0 ? void 0 : detectMethod();
        if (codecParams) {
            Object.assign(res, codecParams);
            if (usePrefer)
                break;
        }
    }
    return res;
}
/**
 * 通过guid计算用户是否在灰度范围内
 *
 * @param {string} guid
 * @param {number} ratio
 */
function isCanaryTarget(guid, ratio) {
    var numValue = parseInt(guid.slice(0, 4), 16);
    var maxValue = 0xffff;
    var targetValue = maxValue * ratio;
    return numValue <= targetValue;
}

/**
 * 获取getinfo的请求参数spadseg值，用于告诉后台是否支持hls中插、videoIn广告能力。
 * @param hlsKernelSptVideoInAd 当前hls内核是否支持videoIn广告
 */
function getSptAdSegParam(hlsKernelSptVideoInAd) {
    if (hlsKernelSptVideoInAd === void 0) { hlsKernelSptVideoInAd = false; }
    // 0x1:支持植入广告
    // 0x2:支持中插广告
    // 0x3都支持
    if (hlsKernelSptVideoInAd) {
        return 3;
    }
    return 2;
}
function getDtypeParam(config) {
    if (uaTool.mobile) {
        var _a = config.businessConfig, businessConfig = _a === void 0 ? {} : _a, _b = config.enableP2PChannlType, enableP2PChannlType = _b === void 0 ? [] : _b, _c = config.enableP2P, enableP2P = _c === void 0 ? false : _c;
        var type = businessConfig.type;
        if (enableP2P || enableP2PChannlType.indexOf(type) !== -1) {
            // 如果配置项中配置了启用p2p，那么一定请求hls流
            return REQ_VOD_STREAM_TYPE.hls;
        }
        // 移动端默认用mp4，因为hls流在移动端兼容性并不是很好，例如ipad有一些奇奇怪怪debug
        return REQ_VOD_STREAM_TYPE.mp4;
    }
    // 其他优先hls流
    return REQ_VOD_STREAM_TYPE.hls;
}
/**
 * 腾讯视频点播请求参数
 */
function getVodBuiltInVideoReqInfoParam(playerConfig, config, getCommonKv, needAdInfo) {
    var _a, _b;
    if (needAdInfo === void 0) { needAdInfo = true; }
    return __awaiter(this, void 0, void 0, function () {
        var businessConfig, userCookies, param, userDefinition, playTxConfig, getinfoAdInfo, playCodecValue, supportedPaidFormat, payFormatValue;
        return __generator(this, function (_c) {
            businessConfig = playerConfig.businessConfig;
            userCookies = getUserCookies();
            param = {
                guid: getCommonKv(COMMON_DATA_KEY.guid),
                platform: businessConfig.platform,
                sdtfrom: businessConfig.sdtfrom,
                appVer: getCommonKv(COMMON_DATA_KEY.appVer),
            };
            userDefinition = getCommonKv(PersistedUserSettings.definition);
            if (userDefinition) {
                param.defn = userDefinition;
            }
            playTxConfig = (config || {});
            /** 是否支持vvip */
            param.spvvpay = 1;
            // 增加特殊广告的支持能力参数
            param.spadseg = getSptAdSegParam(true);
            getinfoAdInfo = getCommonKv(SUPER_DATA_KEY.getinfoAdInfo);
            if (getinfoAdInfo && needAdInfo) {
                param.adsid = getinfoAdInfo.adsid || '';
                param.adpinfo = getinfoAdInfo.adpinfo || '';
            }
            param.dtype = getDtypeParam(playerConfig);
            playCodecValue = getCodecParams(playerConfig, playTxConfig, param);
            Object.assign(param, playCodecValue);
            supportedPaidFormat = playerConfig.supportedPaidFormat;
            if (supportedPaidFormat) {
                payFormatValue = getRequestParamForPaidFormat(supportedPaidFormat);
                Object.assign(param, payFormatValue);
            }
            // 增加登陆态参数
            param.logintoken = Object.keys(userCookies).length > 0
                ? jsonTool.safelyStringify(userCookies)
                : '';
            // 仅在tvk支持的能力，如m3u8直出
            if (playerConfig.enableTVK) {
                // master m3u8代理直出及中插广告
                param.spm3u8tag = 0x40 | 0x01 | 0x02;
                param.spmasterm3u8 = 0x3;
                // 普通m3u8直出
                if (!uaTool.mobile && videoTool.supportMSE()) {
                    param.sphls = 2;
                }
                // 特殊场景：不支持HEVC 4K的设备，展示4K客户端拉动
                if (((_a = playerConfig.tvkConfig) === null || _a === void 0 ? void 0 : _a.showUHDClientGuide)
                    && ((_b = playerConfig.supportedPaidFormat) === null || _b === void 0 ? void 0 : _b.includes(PAID_FORMAT.UHD))
                    && (!param.hevclv || param.hevclv < HEVC_LV_VALUE.UHD)
                    && !videoTool.supportHevc()) {
                    param.hevclv = HEVC_LV_VALUE.UHD_ONLY;
                }
            }
            return [2 /*return*/, param];
        });
    });
}
/**
 * 腾讯视频直播请求参数
 */
function getLiveBuiltInVideoReqInfoParam(playerConfig, config, getCommonKv) {
    return __awaiter(this, void 0, void 0, function () {
        var businessConfig, param, userDefinition, playTxConfig, playCodecValue;
        return __generator(this, function (_a) {
            businessConfig = playerConfig.businessConfig;
            getUserCookies();
            param = {
                guid: getCommonKv(COMMON_DATA_KEY.guid),
                platform: businessConfig.platform,
                sdtfrom: businessConfig.sdtfrom,
                appver: getCommonKv(COMMON_DATA_KEY.appVer),
            };
            userDefinition = getCommonKv(PersistedUserSettings.definition);
            if (userDefinition) {
                param.defn = userDefinition;
            }
            playTxConfig = (config || {});
            param.livepid = playTxConfig.livepid || '';
            param.roomid = playTxConfig.roomid || '';
            // 直播默认可自动降级。只有用户触发的场景不能自动降级，这种场景由外部覆盖这个参数。
            param.defnswitch = 1;
            playCodecValue = getCodecParams(playerConfig, playTxConfig, param);
            Object.assign(param, playCodecValue);
            // 兼容旧的重定向接口
            Object.assign(param, {
                defauto: param.defnswitch,
                appVer: param.appver,
            });
            return [2 /*return*/, param];
        });
    });
}

/** 获取编译注入变量值 */
var envVals = getEnvVals();
/** 广告插件初始化defer。用局部变量保存，保证只加载一次 */
var adInitDefer;
var logMethodCall = logMethodCallDecoratorCreator('SuperPlayer');
var performanceCost = performanceCostDecoratorCreator('SuperPlayer');
/** hls中插偏移值, 单位秒 */
var hlsADShift = 1;
var SuperPlayer = /** @class */ (function (_super) {
    __extends(SuperPlayer, _super);
    function SuperPlayer(config) {
        var _this = this;
        var _a;
        var _b = getSuperConfig(config), superPlayerConfig = _b.superPlayerConfig, lazyPlugins = _b.lazyPlugins;
        if (!superPlayerConfig.isPrivateDeployment) {
            // 采集引用上报信息
            var reporter = ReferenceReport.getReporter();
            // from定义2标识为superplayer
            reporter.collectUsage(2, envVals.CHANNEL, (_a = superPlayerConfig.businessConfig) === null || _a === void 0 ? void 0 : _a.platform);
        }
        _this = _super.call(this, superPlayerConfig) || this;
        /** 直播/点播 */
        _this.type = PLAY_MODE.VOD;
        /** 懒加载的插件配置 */
        _this.lazyPlugins = [];
        /** 根据vvip信息修改传入的startTime(减去广告时间)，同时允许通过keepOriginalStartTime参数指定不修改 */
        _this.videoLoadParamModifier = function (param) {
            var _a, _b;
            if (_this.config.keepOriginalStartTime)
                return param;
            var startTime = param.startTime;
            // 将起点限制在试看范围内
            if (_this.previewDuration > 0) {
                // startTime = Math.min(
                //   this.previewDuration + this.previewStartPosition,
                //   Math.max(this.previewStartPosition, startTime),
                // );
                // case 1：startTime超过了试看区，从试看区的开头进行播放
                // case 2: startTime小于试看区的开头，从试看区的开头进行播放
                if (startTime > _this.previewDuration + _this.previewStartPosition
                    || startTime < _this.previewStartPosition) {
                    startTime = _this.previewStartPosition;
                }
            }
            // 如果存在中插广告，且playtime指定到了中插广告的内部，跳到开头
            var hlsAdRanges = (_a = _this.getCommonKv(SUPER_DATA_KEY.hlsAdRanges)) !== null && _a !== void 0 ? _a : [];
            var rangeAtPlaytime = commonTool.findDiscontinuityTimeRangeAtPlaytime(startTime, hlsAdRanges);
            if (rangeAtPlaytime && startTime) {
                var newStartTime = rangeAtPlaytime.start - hlsADShift;
                _this.log("start time modified due to hls ad, origin: ".concat(startTime, ", new: ").concat(newStartTime));
                return __assign$1(__assign$1({}, param), { startTime: newStartTime });
            }
            // vvip相关逻辑
            if (!((_b = _this.removedAdRange) === null || _b === void 0 ? void 0 : _b.length)) {
                return __assign$1(__assign$1({}, param), { startTime: startTime });
            }
            return __assign$1(__assign$1({}, param), { startTime: _this.getVVIPOffsetTime(startTime) });
        };
        _this.logger = new Logger(_this.config.instanceId, 'SuperPlayer');
        _this.log('new SuperPlayer(), input config=', jsonTool.safelyStringify(config));
        var _c = config.mode, mode = _c === void 0 ? PLAY_MODE.VOD : _c, type = config.type;
        _this.lazyPlugins = lazyPlugins;
        _this.type = (type || mode);
        _this.adLogic = new AdLogic(_this, _this.corePlayer);
        _this.previewLogic = new PreviewLogic(_this);
        _this.posterLogic = new PosterLogic(_this);
        _this.writeGlobalCommonKvs();
        _this.initPlugins();
        _this.initInnerEvts();
        _this.reqExtInfoOnMobile();
        _this.setupRemovedAdRange();
        if (getDebugModeFromUrl()) {
            SuperPlayer._instances[_this.config.instanceId] = _this;
        }
        if (config.videoId || config.adInitConfig) {
            _this.loadAdPlugin();
        }
        if (superPlayerConfig.enableTVK) {
            _this.tvk = enableTVK(_this, superPlayerConfig.tvkConfig);
        }
        return _this;
    }
    Object.defineProperty(SuperPlayer.prototype, "vinfo", {
        /** 当前的播放信息 */
        get: function () {
            return this.currentVideoInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "ctrlbarPlugin", {
        /** 控制栏插件 */
        get: function () {
            return this.plugins[CtrlbarPluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "tipsPlugin", {
        /** 提示信息插件 */
        get: function () {
            return this.plugins[TipsPluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "loadingPlugin", {
        /** 加载图标插件 */
        get: function () {
            return this.plugins[UILoadingPlugin.pluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "errorPagePlugin", {
        /** 错误页插件 */
        get: function () {
            return this.plugins[ErrorPagePluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "posterPlugin", {
        /** 封面图插件 */
        get: function () {
            return this.plugins[PosterPluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "config", {
        /** 配置参数 */
        get: function () {
            return this.corePlayer.config;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "previewDuration", {
        /** 试看时长 */
        get: function () {
            return this.previewLogic.previewDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "previewStartPosition", {
        /** 试看起点 */
        get: function () {
            return this.previewLogic.previewStartPosition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "core", {
        /** @deprecated */
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "coreConfig", {
        /** @deprecated changed to player.config */
        get: function () {
            return this.config;
        },
        enumerable: false,
        configurable: true
    });
    SuperPlayer.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger).log.apply(_a, args);
    };
    SuperPlayer.prototype.warn = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger).warn.apply(_a, args);
    };
    Object.defineProperty(SuperPlayer.prototype, "videoSize", {
        get: function () {
            var _a;
            return this.videoSizeFromGetInfo || ((_a = this.corePlayer) === null || _a === void 0 ? void 0 : _a.videoSize) || { width: 0, height: 0 };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "cnlid", {
        /** 腾讯视频直播流id */
        get: function () {
            if (this.config.type === PLAY_MODE.LIVE) {
                return this.vid;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 降编码重播
     * @param degradeCodecExpireTime 过期时长（单位毫秒），例如hevc降级到h.264播放，效果持续1天，则传入1 * 24 * 3600 * 1000。如果不传或传0，则本地不记录
     * @returns 成功执行重播
     */
    SuperPlayer.prototype.degradeCodecRetry = function (degradeCodecExpireTime) {
        var _a;
        if (degradeCodecExpireTime === void 0) { degradeCodecExpireTime = 0; }
        return (_a = this.startGetinfoRetry) === null || _a === void 0 ? void 0 : _a.call(this, {
            updatePlayParam: {
                videoReqInfoParam: {
                    hevclv: HEVC_LV_VALUE.NOT_SPT,
                },
                videoLoadParam: {
                    startTime: this.playtime,
                    // VideoFlowNode缓存了上一次kernelName，导致降级还会走到wasm内核，比较恶心，后续重构loadParam这一块
                    kernelName: void 0,
                },
            },
            degradeCodecExpireTime: degradeCodecExpireTime,
            degradeReason: DEGRADE_CODEC_REASON.USER,
        }, false);
    };
    /**
     * 删除播放器缓存在localstorage中的数据
     * @param localKey localstorage的key字符串
     * @returns 是否成功删除
     */
    SuperPlayer.prototype.clearLocalstorage = function (localKey) {
        var keyIdx = Object.keys(LOCAL_STORAGE_KEY).findIndex(function (key) { return LOCAL_STORAGE_KEY[key] === localKey; });
        if (keyIdx !== -1) {
            // 只能删除被定义的合法key
            lsTool.delData(localKey);
            return true;
        }
        return false;
    };
    SuperPlayer.prototype.destroy = function () {
        var _a, _b, _c, _d, _e;
        (_a = this.tvk) === null || _a === void 0 ? void 0 : _a.destroy();
        this.tvk = null;
        (_b = this.adLogic) === null || _b === void 0 ? void 0 : _b.destroy();
        this.adLogic = null;
        (_c = this.previewLogic) === null || _c === void 0 ? void 0 : _c.destroy();
        this.previewLogic = null;
        (_d = this.posterLogic) === null || _d === void 0 ? void 0 : _d.destroy();
        this.posterLogic = null;
        // 可能重复销毁
        if (((_e = this.config) === null || _e === void 0 ? void 0 : _e.instanceId) && SuperPlayer._instances[this.config.instanceId]) {
            delete SuperPlayer._instances[this.config.instanceId];
        }
        clearTimeout(this.mouseMoveTimerSuperPlayer);
        return _super.prototype.destroy.call(this);
    };
    // 播控接口，这里分vid和url的版本
    /** 播放，支持指定起播时间点和强制指定内核。
     *
     * 1. 传参为空时执行播放器原生的play方法。
     * 2. 如果有传入vid/cnlid，且加载了getinfo插件时，播控交由getinfo插件实现（id换取url播放）。
     * 3. 传入urlConfig时，直接播放url。
     * @param config {PlayInfoConfig} 需要加载的视频信息（支持url/vid点播/cnlid直播）
     * @param extra 额外配置信息，支持指定起播时间和指定播放内核
     * @returns void
     */
    SuperPlayer.prototype.play = function (playConfig, param) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var centerBtn;
            return __generator(this, function (_c) {
                if (!playConfig) {
                    return [2 /*return*/, this.playByInitConfig()];
                }
                (_a = this.loadingPlugin) === null || _a === void 0 ? void 0 : _a.show();
                centerBtn = (_b = this.ctrlbarPlugin) === null || _b === void 0 ? void 0 : _b.instances.CenterBtn;
                if (centerBtn) {
                    centerBtn.hideEl(centerBtn.playBtn);
                }
                return [2 /*return*/, this.loadOrPlay(playConfig, param, 'play')];
            });
        });
    };
    /**
     * 内部调用视频加载逻辑，播放器load/play接口共用这个方法的逻辑
     * @param funcName 真正调用此逻辑的方法名，因为play接口中复用了load的逻辑，因此在play接口中调用loadInner传入的是'play'
     */
    SuperPlayer.prototype.loadOrPlay = function (playConfig, param, funcName) {
        var _a, _b;
        if (funcName === void 0) { funcName = 'load'; }
        return __awaiter(this, void 0, void 0, function () {
            var config, prePlayConfig, prePlayConfig, _c, vid, cnlid, livepid, extra, buildinVideoReqInfoParam, urlLevels;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!playConfig) {
                            return [2 /*return*/];
                        }
                        // 这个函数执行要早于上一次的playSessionEnd事件。因为目前情况下，如果在播放中重新调用play接口，上一次播放需要在h5player创建节点时才会
                        // 停止播放，当收到上一次的playSessionEnd事件时，这个函数中获取getinfo请求参数之类的逻辑已经走完，因此会有上一次播放残留的参数污染这一
                        // 次播放。
                        // 暂时用clearBeforeReplay函数来提前清理各种参数等。最好的办法其实是在这里await stop()函数。但是修改后发现单测中有很多非法调用（也许
                        // 引用方也是这样调用的），例如play以后马上replay，而不是await play以后replay。这种非法调用在增加await stop以后会出现很多错误。因此
                        // 做了妥协。
                        this.clearBeforeReplay();
                        config = playConfig;
                        // 记录用户的原始播放参数，重播时候直接传入
                        this.replayConfig = playConfig;
                        checkParams(this.type, funcName, config);
                        if (typeof playConfig === 'string') {
                            // 处理传入"b00249eiunm"和{ vid: "b00249eiunm" }的情况，相当于格式化参数
                            if (this.type === PLAY_MODE.LIVE) {
                                prePlayConfig = ((_a = this.currentPlayItem) === null || _a === void 0 ? void 0 : _a.cnlid) ? this.currentPlayItem : {};
                                config = __assign$1(__assign$1({}, prePlayConfig), { cnlid: playConfig });
                            }
                            else {
                                prePlayConfig = ((_b = this.currentPlayItem) === null || _b === void 0 ? void 0 : _b.vid) ? this.currentPlayItem : {};
                                config = __assign$1(__assign$1({}, prePlayConfig), { vid: playConfig });
                            }
                        }
                        _c = config, vid = _c.vid, cnlid = _c.cnlid, livepid = _c.livepid;
                        extra = this.isH5PlayParam(param) ? param : { videoLoadParam: param };
                        // 记录h5player层的当前播放参数（字符串或者IUrlConfig）
                        this.currentPlayItem = vid || cnlid || config;
                        this.playtimeLimiter.clearAllConfig();
                        if (!(hasGetinfoModule(this.config.instanceId) && (vid || cnlid))) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getBuiltInVideoReqInfoParam(config)];
                    case 1:
                        buildinVideoReqInfoParam = _d.sent();
                        if (this._destroyed) {
                            // await过程中都有可能出现播放器被销毁的情况
                            return [2 /*return*/];
                        }
                        extra.videoReqInfoParam = __assign$1(__assign$1({}, buildinVideoReqInfoParam), extra.videoReqInfoParam);
                        return [4 /*yield*/, this.loadAdPlugin()];
                    case 2:
                        _d.sent();
                        if (this._destroyed) {
                            return [2 /*return*/];
                        }
                        // 指定cnlid时 更新轮询插件的pid
                        if (cnlid) {
                            extra.videoReqInfoParam.cnlid = cnlid;
                            // 就算没有livepid也设置，此时不会发起轮询
                            this.getPlugin(LivepollPlugin.pluginName).livepid = livepid;
                            this.setCommonKv(COMMON_DATA_KEY.livepid, livepid);
                        }
                        else if (vid) {
                            extra.videoReqInfoParam.vid = vid;
                        }
                        return [2 /*return*/, _super.prototype[funcName].call(this, vid || cnlid, extra)];
                    case 3:
                        urlLevels = config.levels;
                        this.setLevelOptions(urlLevels, config.url);
                        return [2 /*return*/, _super.prototype[funcName].call(this, config, extra)];
                }
            });
        });
    };
    SuperPlayer.prototype.replay = function () {
        var _a, _b, _c;
        (_b = (_a = this.loadParam) === null || _a === void 0 ? void 0 : _a.videoLoadParam) === null || _b === void 0 ? true : delete _b.startTime;
        var defn = this.getCommonKv(COMMON_DATA_KEY.currentDefn);
        if (this.vid && defn) {
            // replay vid 时需要记住清晰度 defn 参数
            return this.play(this.replayConfig, __assign$1(__assign$1({}, this.loadParam), { videoReqInfoParam: __assign$1(__assign$1({}, (_c = this.loadParam) === null || _c === void 0 ? void 0 : _c.videoReqInfoParam), { defn: defn }) }));
        }
        return this.play(this.replayConfig, this.loadParam);
    };
    /**
     * 加载，仅支持点播模式。支持指定起播时间点和强制指定内核。
     * 1. 传参为空时执行播放器原生的play方法
     * 2. 如果有传入vid/cnlid，且加载了getinfo插件时，播控交由getinfo插件实现（id换取url播放）
     * 3. 传入urlConfig时，直接播放url
     * @param config {PlayInfoConfig} 需要加载的视频信息（支持url/vid点播/cnlid直播）
     * @param extra 额外配置信息，支持指定起播时间和指定播放内核
     */
    SuperPlayer.prototype.load = function (config, param) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!config)
                    return [2 /*return*/, _super.prototype.load.call(this)];
                return [2 /*return*/, this.loadOrPlay(config, param, 'load')];
            });
        });
    };
    /**
     * 预加载，仅支持点播模式。支持指定起播时间点和强制指定内核。
     *
     * @param config {PlayInfoConfig} 需要加载的视频信息（支持vid点播）
     * @param extra 额外配置信息，支持指定起播时间和指定播放内核
     * @param endTime 视频结束时间，以此来判断预加载结束时间
     */
    SuperPlayer.prototype.preload = function (config, param, endTime) {
        return __awaiter(this, void 0, void 0, function () {
            var loadVid, extra, buildinVideoReqInfoParam;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!config)
                            return [2 /*return*/];
                        checkParams(this.type, 'load', config);
                        loadVid = typeof config === 'string' ? config : config === null || config === void 0 ? void 0 : config.vid;
                        extra = this.isH5PlayParam(param) ? param : { videoLoadParam: param };
                        if (!hasGetinfoModule(this.config.instanceId) || !loadVid)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.getBuiltInVideoReqInfoParam(config, false)];
                    case 1:
                        buildinVideoReqInfoParam = _a.sent();
                        if (this._destroyed) {
                            return [2 /*return*/];
                        }
                        extra.videoReqInfoParam = __assign$1(__assign$1({}, buildinVideoReqInfoParam), extra === null || extra === void 0 ? void 0 : extra.videoReqInfoParam);
                        return [2 /*return*/, _super.prototype.preload.call(this, loadVid, extra, endTime)];
                }
            });
        });
    };
    /** Seek 操作，如果在有试看时 seek，则会在下一次timeupdate直接判定试看是否结束 */
    SuperPlayer.prototype.seek = function (time) {
        var seekTargetTime = time;
        var hlsMidRollAdRange = this.getCommonKv(SUPER_DATA_KEY.hlsAdRanges);
        if (hlsMidRollAdRange) {
            // 如果seek到hls中插段内，调整时间点为广告开始位置
            var rangeIncludesTargetTime = commonTool.findDiscontinuityTimeRangeAtPlaytime(seekTargetTime, hlsMidRollAdRange);
            // todo bug 发现部分HEVC中插如果准确seek到起点，会存在GOP丢失的情况
            if (rangeIncludesTargetTime)
                seekTargetTime = rangeIncludesTargetTime.start - hlsADShift;
        }
        return _super.prototype.seek.call(this, seekTargetTime);
    };
    /**
     * 切换清晰度
     *
     * 1. 如果有getinfo插件且使用vid/cnlid播放，则切换清晰度交由getinfo插件实现。
     * 2. 通过url切换清晰度需要先在清晰度列表中添加指定的url。
     * @param defn {string} 切换到的清晰度名称
     * @param extra.userTrigger 是否用户触发的切换清晰度
     */
    SuperPlayer.prototype.setLevel = function (defn, extra) {
        if (extra === void 0) { extra = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var prevDefn_1, commonParam, setLevelReqParam, liveParam, vodParam, getinfoAdInfo, _a, audioTracks, currentAudioTrack_1, track, hardSetLevelFormats, setLevelMode, currentDefnList, nextLevelIndex, nextLevelObj, nextUrls;
            var _this = this;
            return __generator(this, function (_b) {
                if (typeof defn !== 'string') {
                    return [2 /*return*/, Promise.reject('setLevel received illegal parameter')];
                }
                if (hasGetinfoModule(this.config.instanceId) && this.vid) {
                    if (this.state === VIDEO_STATE.PAUSE && this.type === PLAY_MODE.VOD) {
                        // 点播下切换清晰度直接开播
                        this.play();
                    }
                    prevDefn_1 = this.getCommonKv(COMMON_DATA_KEY.currentDefn);
                    if (extra.userTrigger) {
                        // 如果是用户操作的切换清晰度，缓存起来
                        this.setCommonKv(PersistedUserSettings.definition, defn);
                    }
                    commonParam = {
                        defn: defn,
                        // 切清晰度时需要更新 logintoken 登录态
                        logintoken: jsonTool.safelyStringify(getUserCookies()),
                    };
                    setLevelReqParam = void 0;
                    if (this.type === PLAY_MODE.LIVE) {
                        liveParam = __assign$1(__assign$1({}, commonParam), { 
                            // 如果非用户触发的切换清晰度可自动降级
                            defnswitch: extra.userTrigger ? 1 : 0 });
                        // defauto是兼容旧重定向接口
                        Object.assign(liveParam, {
                            defauto: +!liveParam.defnswitch,
                        });
                        setLevelReqParam = liveParam;
                    }
                    else {
                        vodParam = __assign$1({ 
                            // 如果非用户触发的切换清晰度可自动降级
                            fhdswitch: extra.userTrigger ? 1 : 0 }, commonParam);
                        getinfoAdInfo = this.getCommonKv(SUPER_DATA_KEY.getinfoAdInfo);
                        if (getinfoAdInfo) {
                            vodParam.adsid = getinfoAdInfo.adsid || '';
                            vodParam.adpinfo = getinfoAdInfo.adpinfo || '';
                        }
                        _a = this.currentVideoInfo, audioTracks = _a.audioTracks, currentAudioTrack_1 = _a.currentAudioTrack;
                        if (audioTracks.length > 1) {
                            track = audioTracks.find(function (item) { return item.id === currentAudioTrack_1; });
                            // 切换清晰度时携带多音轨信息
                            track && Object.assign(vodParam, {
                                track: track.name,
                            });
                        }
                        setLevelReqParam = vodParam;
                    }
                    hardSetLevelFormats = [FORMAT.DOLBY, FORMAT.HDR10, FORMAT.SFR_HDR];
                    setLevelMode = extra.setLevelMode;
                    if (hardSetLevelFormats.indexOf(prevDefn_1) !== -1 || hardSetLevelFormats.indexOf(defn) !== -1) {
                        // 判断如果是hdr等特殊清晰度相关的切换，都使用硬切
                        setLevelMode = SET_LEVEL_MODE.HARD;
                    }
                    return [2 /*return*/, _super.prototype.setLevel.call(this, setLevelReqParam, { setLevelMode: setLevelMode }).catch(function (err) {
                            _this.log(err);
                            // 回滚当前清晰度
                            if (_this.ctrlbarPlugin) {
                                _this.ctrlbarPlugin.level = prevDefn_1;
                            }
                            _this.setCommonKv(COMMON_DATA_KEY.currentDefn, prevDefn_1);
                        })];
                }
                currentDefnList = this.getCommonKv(COMMON_DATA_KEY.currentDefnList);
                nextLevelIndex = currentDefnList === null || currentDefnList === void 0 ? void 0 : currentDefnList.findIndex(function (item) { return item.value === defn; });
                nextLevelObj = currentDefnList[nextLevelIndex];
                if (!nextLevelObj)
                    return [2 /*return*/, Promise.reject(new Error('no definition info'))];
                nextUrls = nextLevelObj.url;
                if (!nextUrls && this.defnIdToUrl) {
                    nextUrls = this.defnIdToUrl(defn);
                    nextLevelObj.url = nextUrls;
                }
                if (!nextUrls)
                    return [2 /*return*/, Promise.reject(new Error('definition must contains url'))];
                this.setCommonKv(COMMON_DATA_KEY.currentDefn, defn);
                this.levelList = currentDefnList;
                this.level = nextLevelObj.value;
                // 更新重播地址
                this.replayConfig.url = nextUrls;
                return [2 /*return*/, _super.prototype.setLevel.call(this, __assign$1(__assign$1({}, this.replayConfig), { levels: void 0, 
                        // 上面的信息不能丢，例如切换前urlConfig的kernelName等，但levels属性不需要，core不关心清晰度列表
                        defn: nextLevelObj.value, url: nextLevelObj.url, level: nextLevelObj, levelIndex: nextLevelIndex }))];
            });
        });
    };
    /**
     * 获取指定插件
     * @param name 插件名（Plugin.pluginName）
     */
    SuperPlayer.prototype.getPlugin = function (name) {
        return this.plugins[name];
    };
    /**
     * 此方法为播放器的付费逻辑行为。跳过广告、切换清晰度等如果触发付费行为，外部可能拉起弹窗并暂停当前播放。
     * 如果观看者关掉弹窗，引用方需要调用此方法，使播放器恢复播放或其他行为。
     * <br>
     * 以广告播放为例，广告插件配置传入的回调函数参数`showOpenVIPGuide`。当前贴广告播放时，用户点击了右上角的“跳过广告”按钮，此时广告插件会调
     * 用`showOpenVIPGuide`方法，页面在此方法中拉起了一个付费弹窗用于提示用户进行付费等行为，并且暂停了广告播放。如果用户选择关闭此弹窗，播放
     * 器需要恢复广告播放，因此页面需要调用此方法恢复正常广告播放。
     */
    SuperPlayer.prototype.closePayTipsCallback = function (type) {
        var adPlugin = getAdPlugin(this.config.instanceId);
        if (type === 'ad' && typeof (adPlugin === null || adPlugin === void 0 ? void 0 : adPlugin.resumeAd) === 'function') {
            adPlugin.resumeAd();
        }
    };
    SuperPlayer.prototype.createPlugin = function (insName, option) {
        if (option === void 0) { option = {}; }
        var _a = option.pluginName, pluginName = _a === void 0 ? insName : _a;
        if (pluginName === AdPluginName) {
            _super.prototype.createPlugin.call(this, insName, __assign$1(__assign$1({}, option), { requestProxyHttp: this.requestAdCallback4AdPlugin.bind(this) }));
        }
        else {
            _super.prototype.createPlugin.call(this, insName, option);
        }
    };
    SuperPlayer.prototype.setAdConfig = function (config) {
        return this.waitAdPlugin().then(function (ad) { return ad.setConf(config); });
    };
    /** 调节container尺寸时需要调用此方法，同步更新广告尺寸 */
    SuperPlayer.prototype.resizeAd = function () {
        return this.waitAdPlugin().then(function (ad) { var _a; return (_a = ad.resizeAd) === null || _a === void 0 ? void 0 : _a.call(ad); });
    };
    /** 如果调节container尺寸是异步的，在resize前可以调用这个方法先隐藏广告；resize完成后再调用resizeAd展示广告 */
    SuperPlayer.prototype.hideAdBeforeResize = function () {
        return this.waitAdPlugin().then(function (ad) { var _a; return (_a = ad.hideAdBeforeResize) === null || _a === void 0 ? void 0 : _a.call(ad); });
    };
    /** 输入原播放时间，输出减去或者加上广告后的时间
     * @param playtime 原播放时间
     * @param isPlus 是否反向计算、加上广告时长，默认是减去广告时长
     */
    SuperPlayer.prototype.getVVIPOffsetTime = function (playtime, isPlus) {
        if (isPlus === void 0) { isPlus = false; }
        var removedAdRange = this.removedAdRange;
        if (!(removedAdRange === null || removedAdRange === void 0 ? void 0 : removedAdRange.length))
            return playtime;
        if (isPlus)
            return this.getPlusAdOffsetTime(playtime);
        /** 需要减去的时间 */
        var skipTime = 0;
        for (var i = 0; i < removedAdRange.length; i++) {
            var _a = removedAdRange[i], start = _a.start, end = _a.end;
            if (start > playtime)
                break;
            if (end > playtime) {
                // 落在广告内，返回广告开始的时间点(减去已播放的广告时长)
                skipTime += (playtime - start);
                break;
            }
            else {
                skipTime += end - start;
            }
        }
        return playtime - skipTime;
    };
    SuperPlayer.prototype.startGetinfoRetry = function (retryConfig, fatal) {
        var _a;
        var _b = retryConfig.degradeCodecExpireTime, degradeCodecExpireTime = _b === void 0 ? 0 : _b, _c = retryConfig.degradeReason, degradeReason = _c === void 0 ? DEGRADE_CODEC_REASON.UNKNOWN : _c;
        if (degradeReason === DEGRADE_CODEC_REASON.USER) {
            // 用户触发重试，再检查下是否可以重试，其他reason不需要再走这个判断了
            if (!this.canGetinfoRetry()) {
                return false;
            }
        }
        if (degradeCodecExpireTime > 0) {
            // 写入这些信息便于记录降级时播放器的一些信息
            var extraInfo = {
                playerSize: domTool.getDomSize(this.player.container),
                videoSize: this.player.videoSize,
                url: location.href,
                topUrl: urlTool.getTopFrameUrl(),
                kernelName: this.player.kernelName,
                flowid: this.player.getCommonKv(COMMON_DATA_KEY.flowid),
                guid: this.player.getCommonKv(COMMON_DATA_KEY.guid),
                playtime: this.player.playtime,
                duration: this.player.duration,
                vid: this.player.vid,
                loadingUrl: (_a = this.player.currentVideoInfo) === null || _a === void 0 ? void 0 : _a.loadingUrl,
            };
            this.logger.log("start degrade retry, degradeReason=".concat(degradeReason, ", extraInfo=").concat(jsonTool.safelyStringify(extraInfo)));
            // 写入localstorage记录超时时间
            writeDegradeCodecToLocal(degradeCodecExpireTime, degradeReason, extraInfo);
        }
        return _super.prototype.startGetinfoRetry.call(this, retryConfig, fatal);
    };
    SuperPlayer.prototype.getRetryCheckClasses = function () {
        return RetryClasses;
    };
    /** 加上广告时长后，需要存储的原始时间 */
    SuperPlayer.prototype.getPlusAdOffsetTime = function (playtime) {
        return this.removedAdRange.reduce(function (prev, cur) {
            var start = cur.start, end = cur.end;
            if (start <= prev) {
                prev += end - start;
            }
            return prev;
        }, playtime);
    };
    SuperPlayer.prototype.waitAdPlugin = function () {
        var _this = this;
        var _a;
        var adPlugin = getAdPlugin((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceId);
        if (adPlugin)
            return Promise.resolve(adPlugin);
        return new Promise(function (resolve) {
            _this.pluginMsg.on("pluginsetup:".concat(AdPluginName), function () {
                resolve(getAdPlugin(_this.config.instanceId));
            });
        });
    };
    SuperPlayer.prototype.playByInitConfig = function () {
        var _a = this.config, videoId = _a.videoId, _b = _a.videoInitConfig, videoInitConfig = _b === void 0 ? videoId : _b;
        // 这里的判断条件为config中没有videoId且当前没有通过其他途径设置过playItem(load,play接口)
        if (!videoInitConfig || this.currentPlayItem)
            return _super.prototype.play.call(this);
        return this.play(videoInitConfig);
    };
    /** 插入到后贴之前的合并接口节点。url模式不插入 */
    SuperPlayer.prototype.nodeBeforePostAd = function (reqInfo) {
        if (!uaTool.mobile && this.previewLogic.previewDuration !== NO_PREVIEW_FLAG) {
            // pc端试看不请求后贴
            return null;
        }
        return _super.prototype.nodeBeforePostAd.call(this, reqInfo);
    };
    SuperPlayer.prototype.setupRemovedAdRange = function () {
        var _this = this;
        this.on(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, function (_a) {
            var data = _a.data;
            if (data.code !== ErrorCode.SUC || _this.config.type === PLAY_MODE.LIVE)
                return;
            try {
                var _b = data.data, parseData = _b.parseData, reqParams = _b.reqParams;
                var _c = parseData.vitem, pureVid = _c.purevid, _d = _c.dotinfo, dotInfo = _d === void 0 ? '' : _d;
                if (pureVid && reqParams.vid !== pureVid && dotInfo) {
                    _this.removedAdRange = JSON.parse(dotInfo).dot_time.map(function (v) { return ({
                        start: +v.start_time / 1000,
                        end: +v.end_time / 1000,
                    }); });
                }
                else {
                    _this.removedAdRange = null;
                }
            }
            catch (err) {
                _this.log('set ad range err,', err);
                _this.removedAdRange = null;
            }
        });
    };
    SuperPlayer.prototype.selectGetinfoModule = function (config) {
        var _a = config.type, type = _a === void 0 ? PLAY_MODE.VOD : _a, getinfoModule = config.getinfoModule, enableTVK = config.enableTVK;
        if (!enableTVK) {
            return null;
        }
        var targetReqPlugin;
        if (getinfoModule) {
            return getinfoModule;
        }
        if (type === PLAY_MODE.VOD) {
            targetReqPlugin = VodGetinfo;
        }
        else {
            targetReqPlugin = LiveGetinfo;
        }
        return targetReqPlugin;
    };
    SuperPlayer.prototype.initPlugins = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config.lazyInitPlugins) return [3 /*break*/, 3];
                        this.setCacheStatus(true);
                        this.setReplayType(0);
                        return [4 /*yield*/, this.waitLoadStart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadPlayerPlugins()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.initAdPlugin();
                        this.initErrorPage();
                        this.initTipsPlugin();
                        this.initCtrlbarPlugin();
                        this.initLivepoll();
                        this.initLoadingPlugin();
                        this.clearCache();
                        return [2 /*return*/];
                }
            });
        });
    };
    SuperPlayer.prototype.waitLoadStart = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.once(H5_PLAY_EVENT.VIDEO_LOAD_START, function () { return resolve(); });
            setTimeout(function () {
                resolve();
            }, 200);
        });
    };
    SuperPlayer.prototype.initAdPlugin = function () {
        var _this = this;
        var ctrlbarPlugin = this.ctrlbarPlugin;
        if (!ctrlbarPlugin)
            return;
        // 全屏变化时调用resizeAd
        ctrlbarPlugin.on(CTRL_EVENTS.FAKE_FULLSCREEN_CHANGE, function () { return _this.resizeAd(); });
        ctrlbarPlugin.on(CTRL_EVENTS.FULLSCREEN_CHANGE, function () {
            // 系统全屏是异步操作，先隐藏角标广告 等全屏后再展示
            _this.hideAdBeforeResize();
            var fullscreenFinishDelay = 300;
            setTimeout(function () {
                _this.resizeAd();
            }, fullscreenFinishDelay);
        });
    };
    SuperPlayer.prototype.reqExtInfoOnMobile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, videoId, _b, enableGetExtInfo, platform, duration;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.config, videoId = _a.videoId, _b = _a.enableGetExtInfo, enableGetExtInfo = _b === void 0 ? true : _b;
                        if (!enableGetExtInfo || !uaTool.mobile || typeof videoId !== 'string')
                            return [2 /*return*/];
                        platform = this.getCommonKv(COMMON_DATA_KEY.platform);
                        return [4 /*yield*/, requestVideoExtInfo({ vid: videoId, platform: platform })];
                    case 1:
                        duration = (_c.sent()).duration;
                        if (this.state === VIDEO_STATE.IDLE
                            && !this.played
                            && this.ctrlbarPlugin) {
                            this.ctrlbarPlugin.duration = duration;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SuperPlayer.prototype.initLoadingPlugin = function () {
        var _this = this;
        // 为了降低复杂度，loading动画在super-player统一控制，因此插件中不会监听各种事件来处理loading动画的显隐
        this.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_START, function () { var _a; return (_a = _this.loadingPlugin) === null || _a === void 0 ? void 0 : _a.show(); });
        this.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, function () { var _a; return (_a = _this.loadingPlugin) === null || _a === void 0 ? void 0 : _a.hide(); });
        this.pluginMsg.on(H5_EXT_EVENT.RETRY_PLAY, function (_a) {
            var _b, _c;
            var data = _a.data;
            // 播放级别重试时，可能先会长时间停留在getinfo阶段，因此先展示loading动画
            (_b = _this.loadingPlugin) === null || _b === void 0 ? void 0 : _b.show();
            // 降级播放的tips将语意模糊一下
            (_c = _this.tipsPlugin) === null || _c === void 0 ? void 0 : _c.show(!!(data === null || data === void 0 ? void 0 : data.degradeReason)
                ? t(i18nConfig.superPlayer.TIPS_DEGRADE_TEXT_REASON)
                : t(i18nConfig.superPlayer.TIPS_DEGRADE_TEXT_NO_REASON));
        });
    };
    SuperPlayer.prototype.initLivepoll = function () {
        var _this = this;
        var livepoll = this.plugins[LivepollPlugin.pluginName];
        if (!livepoll)
            return;
        livepoll.on(LIVE_EVENTS.statusChange, function (_a) {
            var _b;
            var data = _a.data;
            if (data.new === LIVE_STATUS.OVER) {
                (_b = _this.errorPagePlugin) === null || _b === void 0 ? void 0 : _b.show({
                    text: t(i18nConfig.superPlayer.LIVE_STREAM_END),
                    hideRefresh: true,
                });
            }
        });
    };
    SuperPlayer.prototype.initErrorPage = function () {
        var _this = this;
        if (!this.errorPagePlugin)
            return;
        var i18nSuperConfig = i18nConfig.superPlayer;
        this.errorPagePlugin.on(ErrorPagePluginEvents.REPORT_LOG, function () { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.offlineLog.reportLogs({
                                reportSource: 'error-page:click',
                            })];
                    case 1:
                        _c.sent();
                        (_a = this.tipsPlugin) === null || _a === void 0 ? void 0 : _a.show(t(i18nSuperConfig.ERROR_PAGE_REPORT_SUCCESS));
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        (_b = this.tipsPlugin) === null || _b === void 0 ? void 0 : _b.show(t(i18nSuperConfig.ERROR_PAGE_REPORT_FAILED, err_1 === null || err_1 === void 0 ? void 0 : err_1.message));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    SuperPlayer.prototype.initTipsPlugin = function () {
        var _this = this;
        if (!this.tipsPlugin)
            return;
        this.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, function (_a) {
            var _b, _c, _d;
            var data = _a.data;
            var defn = _this.getCommonKv(COMMON_DATA_KEY.currentDefn);
            var urlLevel = (_b = _this.levelList) === null || _b === void 0 ? void 0 : _b.find(function (v) { return v.value === defn; });
            var urlLevelName = ((_d = (_c = urlLevel === null || urlLevel === void 0 ? void 0 : urlLevel.payload) === null || _c === void 0 ? void 0 : _c.trim) === null || _d === void 0 ? void 0 : _d.call(_c)) || (urlLevel === null || urlLevel === void 0 ? void 0 : urlLevel.label);
            _this.tipsPlugin.show(data.code !== ErrorCode.SUC
                ? "".concat(data.message || t(i18nConfig.superPlayer.DEFN_SWITCH_FAILED)) : t(i18nConfig.superPlayer.DEFN_SWITCH_SUCCESS, urlLevelName));
        });
    };
    SuperPlayer.prototype.initCtrlbarPlugin = function () {
        var _this = this;
        var superI18nConfig = i18nConfig.superPlayer;
        if (!this.ctrlbarPlugin)
            return;
        this.ctrlbarPlugin.level = this.getCommonKv(COMMON_DATA_KEY.currentDefn);
        this.ctrlbarPlugin.audio = this.getCommonKv(COMMON_DATA_KEY.currentAudioTrack);
        this.ctrlbarPlugin.lang = this.getCommonKv(COMMON_DATA_KEY.currentSubtitle);
        this.pluginMsg.on(H5_EXT_EVENT.DATASET_UPDATE, function (e) {
            var data = e.data;
            var key = data.key, newVal = data.newVal, oldVal = data.oldVal;
            if (newVal === oldVal)
                return;
            var list;
            switch (key) {
                case COMMON_DATA_KEY.currentAudioTrackList:
                    _this.ctrlbarPlugin.audioOpts = newVal;
                    break;
                case COMMON_DATA_KEY.currentAudioTrack:
                    _this.ctrlbarPlugin.audio = newVal;
                    break;
                case COMMON_DATA_KEY.currentDefn:
                    _this.ctrlbarPlugin.level = newVal;
                    _this.level = newVal;
                    break;
                case COMMON_DATA_KEY.currentDefnList:
                    if (!newVal || newVal.length <= 1) {
                        _this.ctrlbarPlugin.levelOpts = [];
                        break;
                    }
                    list = [].concat(newVal);
                    _this.ctrlbarPlugin.levelOpts = list;
                    _this.levelList = list;
                    break;
            }
        });
        this.ctrlbarPlugin.on(CTRL_EVENTS.SET_LEVEL, function (param) {
            var _a, _b;
            if (!_this.checkCanSetLevel())
                return;
            var _c = param.data, value = _c.value, payload = _c.payload, label = _c.label;
            // 切换清晰度的tips持久化，直到切换完成。
            (_a = _this.tipsPlugin) === null || _a === void 0 ? void 0 : _a.show({
                text: t(superI18nConfig.DEFN_SWITCHING, ((_b = payload === null || payload === void 0 ? void 0 : payload.trim) === null || _b === void 0 ? void 0 : _b.call(payload)) || label),
                time: -1,
            });
            _this.setLevel(value, { userTrigger: true });
        });
        var onSetAudioTrackFail = function () {
            _this.tipsPlugin.show(t(superI18nConfig.AUDIO_SWITCH_FAILED));
            _this.ctrlbarPlugin.audio = _this.currentVideoInfo.currentAudioTrack;
        };
        var onSetAudioTrackSuccess = function (label) {
            _this.tipsPlugin.show(t(superI18nConfig.AUDIO_SWITCH_SUCCESS, label));
        };
        this.ctrlbarPlugin.on(CTRL_EVENTS.SET_AUDIO, function (param) {
            var _a;
            var _b = param.data, label = _b.label, value = _b.value;
            (_a = _this.tipsPlugin) === null || _a === void 0 ? void 0 : _a.show({
                text: t(superI18nConfig.AUDIO_SWITCHING, label),
                time: -1,
            });
            _this.setAudioTrack(value)
                .then(function (_a) {
                var fail = _a.fail;
                if (fail)
                    onSetAudioTrackFail();
                else
                    onSetAudioTrackSuccess(label);
            })
                .catch(function () {
                onSetAudioTrackFail();
            });
        });
        this.on(PLAY_EVENT.SET_AUDIO_TRACK_OVER, function (evt) {
            _this.setCommonKv(COMMON_DATA_KEY.currentAudioTrack, evt.data.id);
        });
        this.ctrlbarPlugin.on(CTRL_EVENTS.TEST_EVENT, function () {
            var _a;
            (_a = _this.getPlugin(InfoPanelPluginName)) === null || _a === void 0 ? void 0 : _a.show();
        });
        // 鼠标自动隐藏时间间隔
        var hideMouseDelay = 5000;
        this.container.addEventListener('mousemove', function () {
            clearTimeout(_this.mouseMoveTimerSuperPlayer);
            _this.mouseMoveTimerSuperPlayer = setTimeout(_this.hideMouseOnSuperPlayer.bind(_this), hideMouseDelay);
        });
    };
    SuperPlayer.prototype.hideMouseOnSuperPlayer = function () {
        var _a, _b;
        if (!this.ctrlbarPlugin)
            return;
        var isMouseHoverControl = this.ctrlbarPlugin.instances.CtrlShow.isMouseHoverControl;
        if (this.config.autoHideMouse || (((_a = this.ctrlbarPlugin.instances.Fullscreen) === null || _a === void 0 ? void 0 : _a.isFullScreen)
            && this.state === VIDEO_STATE.PLAYING)) {
            if (isMouseHoverControl) {
                this.container.style.cursor = 'auto';
            }
        }
        else {
            if (((_b = this.ctrlbarPlugin.instances.FakeFullscreen) === null || _b === void 0 ? void 0 : _b.isFullScreen)
                && this.state === VIDEO_STATE.PLAYING && !isMouseHoverControl) {
                this.container.style.cursor = 'none';
            }
        }
    };
    SuperPlayer.prototype.setLevelOptions = function (urlLevels, playUrl) {
        var _a;
        if (urlLevels) {
            var list = urlLevels.list;
            var defaultLevel = ((_a = list.find(function (i) { return i.default || i.url === playUrl; })) === null || _a === void 0 ? void 0 : _a.value) || list[0].value;
            this.setCommonKv(COMMON_DATA_KEY.currentDefn, defaultLevel);
            this.setCommonKv(COMMON_DATA_KEY.currentDefnList, list);
            this.levelList = list;
            this.level = defaultLevel;
            this.defnIdToUrl = urlLevels.callback;
        }
        else {
            // 上一个urlConfig可能有传levels了然后被cache了，所以下一个urlConfig可能需要清除cache
            this.setCommonKv(COMMON_DATA_KEY.currentDefn, void 0);
            this.setCommonKv(COMMON_DATA_KEY.currentDefnList, void 0);
            this.levelList = void 0;
            this.level = void 0;
            this.defnIdToUrl = void 0;
        }
    };
    /** 判断入参是否h5player层定义的load参数 */
    SuperPlayer.prototype.isH5PlayParam = function (config) {
        if (config === void 0) { config = {}; }
        var h5config = config;
        return !!(h5config.videoReqInfoParam || h5config.videoLoadParam || h5config.adParam || h5config.playTimeLimit);
    };
    SuperPlayer.prototype.initInnerEvts = function () {
        var _this = this;
        this.pluginMsg.on(H5_EXT_EVENT.GETINFO_OVER, function (_a) {
            var _b;
            var data = _a.data;
            var resData = (data || {}).resData;
            var vi = (((_b = resData === null || resData === void 0 ? void 0 : resData.vl) === null || _b === void 0 ? void 0 : _b.vi) || [])[0];
            if (vi) {
                var vw = vi.vw, vh = vi.vh;
                // 在getinfo返回里面尝试取一下视频分辨率
                _this.videoSizeFromGetInfo = { width: vw, height: vh };
            }
        });
        // 移动端限播时，提前加载后贴cgi
        if (uaTool.mobile) {
            this.on(H5_PLAY_EVENT.VIDEO_TIMEUPDATE, function (_a) {
                var data = _a.data;
                if (_this.previewDuration === NO_PREVIEW_FLAG)
                    return;
                var postAdPreloadTime = 10;
                if (data.playtime >= _this.previewDuration - postAdPreloadTime) {
                    // 这里会预加载后贴节点。移动端默认使用单 video 模式，不会实际预加载广告视频
                    _this.loadPostAd();
                }
            });
        }
    };
    /**
     * 写入一些静态的全局变量到数据中心，这些数据在播放器销毁时都不会变化。
     */
    SuperPlayer.prototype.writeGlobalCommonKvs = function () {
        // 这里 appVer 字段定为 super-player 版本号
        // 在生产环境 rollup 打包时注入为 @tencent/super-player 下 package.json 的 version 字段
        // 而在 super-demo 下跑 demo 时，则注入为 super-demo/package.json 的 version 字段
        this.setCommonKv(COMMON_DATA_KEY.appVer, envVals.VERSION);
        this.setCommonKv(this.config.businessConfig);
        this.writeLoginCommonKV();
    };
    SuperPlayer.prototype.getDefnNameById = function (id) {
        var _a, _b;
        var defn = (_b = (_a = this.getinfoCtx) === null || _a === void 0 ? void 0 : _a.parseData) === null || _b === void 0 ? void 0 : _b.definitionList.find(function (v) { return v.name === id; });
        if (defn) {
            var _c = formatDefnName(defn.cname, this.type === PLAY_MODE.LIVE), _d = _c[0], nameC = _d === void 0 ? '' : _d, _e = _c[1], nameN = _e === void 0 ? '' : _e;
            return "".concat(nameN, " ").concat(nameC).trim();
        }
        return '';
    };
    SuperPlayer.prototype.requestProxyHttpOnlyAd = function (adType, adReqParam) {
        return __awaiter(this, void 0, void 0, function () {
            var adPlugin, adRequestor, adReqParams, proxyHttpCtx, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        adPlugin = getAdPlugin(this.config.instanceId);
                        if (!adPlugin)
                            return [2 /*return*/];
                        adRequestor = new ProxyHttp(this.config, { pluginMsg: this.pluginMsg });
                        adReqParams = getAdReqParams(this.config.instanceId, __assign$1({ vid: this.curReqInfo.vid, adType: adType }, adReqParam));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, adRequestor.request(adReqParams, null)];
                    case 2:
                        proxyHttpCtx = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.warn("proxyhttp request err in catch, ".concat(e_1));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, proxyHttpCtx];
                }
            });
        });
    };
    /** 传给广告插件使用 */
    SuperPlayer.prototype.requestAdCallback4AdPlugin = function (adType, adReqParam) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var adPlugin, proxyHttpCtx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        adPlugin = getAdPlugin(this.config.instanceId);
                        if (!adPlugin)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.requestProxyHttpOnlyAd(adType, adReqParam)];
                    case 1:
                        proxyHttpCtx = _b.sent();
                        if ((_a = proxyHttpCtx === null || proxyHttpCtx === void 0 ? void 0 : proxyHttpCtx.parseData) === null || _a === void 0 ? void 0 : _a.ad) {
                            // 请求到数据以后把广告订单再设置到 reqInfo 缓存
                            adPlugin.setAdInfo(proxyHttpCtx.parseData.ad);
                        }
                        return [2 /*return*/, proxyHttpCtx];
                }
            });
        });
    };
    SuperPlayer.prototype.requestAdCallback = function (adType, adReqParam) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var ctx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.requestProxyHttpOnlyAd(adType, adReqParam)];
                    case 1:
                        ctx = _b.sent();
                        return [2 /*return*/, (_a = ctx === null || ctx === void 0 ? void 0 : ctx.parseData) === null || _a === void 0 ? void 0 : _a.ad];
                }
            });
        });
    };
    SuperPlayer.prototype.stop = function (endState) {
        this.videoSizeFromGetInfo = null;
        return _super.prototype.stop.call(this, endState);
    };
    SuperPlayer.prototype.emit = function (event, eventObject) {
        return _super.prototype.emit.call(this, event, eventObject);
    };
    SuperPlayer.prototype.on = function (event, listener, priority) {
        return _super.prototype.on.call(this, event, listener, priority);
    };
    SuperPlayer.prototype.once = function (event, listener) {
        return _super.prototype.once.call(this, event, listener);
    };
    SuperPlayer.prototype.off = function (event, listener) {
        return _super.prototype.off.call(this, event, listener);
    };
    SuperPlayer.prototype.listeners = function (event) {
        return _super.prototype.listeners.call(this, event);
    };
    SuperPlayer.prototype.listenerCount = function (event) {
        return _super.prototype.listenerCount.call(this, event);
    };
    /** 将登录态相关cookie写入数据中心 */
    SuperPlayer.prototype.writeLoginCommonKV = function () {
        var _a, _b;
        var _c;
        var getCookie = function (key) { return cookieTool.get(key); };
        // 以下逻辑参考自txplayer/v4-h5-report.js
        var authData = getUserCookies();
        this.setCommonKv((_a = {},
            _a[COMMON_DATA_KEY.hc_main_login] = authData[COOKIE_NAME.MAIN_LOGIN],
            _a[COMMON_DATA_KEY.hc_vuserid] = authData[COOKIE_NAME.VUSERID],
            _a[COMMON_DATA_KEY.hc_openid] = authData[COOKIE_NAME.OPENID],
            _a[COMMON_DATA_KEY.hc_appid] = authData[COOKIE_NAME.APPID],
            _a[COMMON_DATA_KEY.hc_access_token] = authData[COOKIE_NAME.ACCESS_TOKEN],
            _a));
        var guid = authData[COOKIE_NAME.GUID] || cookieTool.get(COOKIE_NAME.GUID);
        if (guid) {
            this.setCommonKv(COMMON_DATA_KEY.guid, guid);
            lsTool.setData(LOCAL_KEY.GUID, guid);
        }
        var isQQ = authData[COOKIE_NAME.MAIN_LOGIN] === 'qq';
        var qqNum = (_c = (getCookie('luin') || getCookie('uin'))) === null || _c === void 0 ? void 0 : _c.replace(/\D/g, '').replace(/^0+/, '');
        this.setCommonKv((_b = {},
            _b[COMMON_DATA_KEY.loginid] = isQQ ? qqNum : getCookie('openid'),
            _b[COMMON_DATA_KEY.loginex] = isQQ ? getCookie('openid') : qqNum,
            _b));
        var loginType = { qq: 1, wx: 2 };
        this.setCommonKv(COMMON_DATA_KEY.logintype, loginType[authData[COOKIE_NAME.MAIN_LOGIN]] || 0);
        this.setCommonKv(COMMON_DATA_KEY.hc_vuession, authData[COOKIE_NAME.VUSESSION]);
    };
    SuperPlayer.prototype.loadAdPlugin = function () {
        var _this = this;
        var _a = this.config.enableCreativePlugin, enableCreativePlugin = _a === void 0 ? true : _a;
        // 域名白名单内不加载任何广告
        if (!enableCreativePlugin || envVals.LOCAL_DEV || isInDomainWhiteList) {
            return Promise.resolve();
        }
        var adInitConfig = getAdInitConfig(this.config);
        // 加载一次广告cdn
        if (adInitDefer) {
            return adInitDefer.then(function () {
                if (!getAdPlugin(_this.config.instanceId) && H5Player.getPlugin(AdPluginName)) {
                    _this.createPlugin(AdPluginName, adInitConfig);
                }
            });
        }
        /** 站内允许自定义广告插件版本号 */
        var adPluginVersion = isOfficialDomain() && this.config.adVersion ? this.config.adVersion : adVersion;
        var adScriptUrl = "https://vm.gtimg.cn/thumbplayer/creative/".concat(adPluginVersion, "/creative-player-").concat(uaTool.mobile ? 'm' : 'v', ".js");
        adInitDefer = this.loadPlugin({
            url: adScriptUrl,
            globalName: adGlobalName,
            pluginName: AdPluginName,
            timeout: adScriptMaxLoadTime,
            config: adInitConfig,
            crossOrigin: 'anonymous',
        }).catch(function (error) {
            // 广告加载失败时直接播放正片即可
            _this.log("adPlugin load fail. ".concat(error === null || error === void 0 ? void 0 : error.message));
        });
        return adInitDefer;
    };
    SuperPlayer.prototype.loadPlayerPlugins = function (retryTimes) {
        if (retryTimes === void 0) { retryTimes = 2; }
        return __awaiter(this, void 0, void 0, function () {
            var plugins, exitPlugins, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (retryTimes <= 0 || !this.lazyPlugins.length)
                            return [2 /*return*/];
                        plugins = this.lazyPlugins.map(function (item) { return (typeof item === 'string' ? item : item[0]); });
                        exitPlugins = H5Player.getPlugins(plugins) || {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!(Object.keys(exitPlugins).length !== plugins.length)) return [3 /*break*/, 3];
                        return [4 /*yield*/, domTool.loadScript(PLUGINS_URL, undefined, 10000)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.createPlugins(this.lazyPlugins)];
                    case 4:
                        err_2 = _a.sent();
                        this.log("super-player-plugins load fail. ".concat(err_2 === null || err_2 === void 0 ? void 0 : err_2.message));
                        return [3 /*break*/, 5];
                    case 5: return [4 /*yield*/, this.loadPlayerPlugins(retryTimes - 1)];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 在重新播放前的清理工作。
     */
    SuperPlayer.prototype.clearBeforeReplay = function () {
        // 重新播放要清掉数据中心中跟广告信息相关数据，避免干扰下一次播放
        this.setCommonKv(SUPER_DATA_KEY.hlsAdRanges, null);
        this.setCommonKv(SUPER_DATA_KEY.getinfoAdInfo, null);
    };
    SuperPlayer.prototype.getBuiltInVideoReqInfoParam = function (playConfig, needAdInfo) {
        if (needAdInfo === void 0) { needAdInfo = true; }
        return __awaiter(this, void 0, void 0, function () {
            var getCommonKv;
            return __generator(this, function (_a) {
                getCommonKv = this.getCommonKv.bind(this);
                // 腾讯视频的点播，直播请求参数是不一致的，需要分开生成，避免串了
                if (this.type === PLAY_MODE.VOD) {
                    return [2 /*return*/, getVodBuiltInVideoReqInfoParam(this.config, playConfig, getCommonKv, needAdInfo)];
                }
                return [2 /*return*/, getLiveBuiltInVideoReqInfoParam(this.config, playConfig, getCommonKv)];
            });
        });
    };
    /** debug属性，保存所有实例 */
    SuperPlayer._instances = {};
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "destroy", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "play", null);
    __decorate([
        performanceCost,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, String]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "loadOrPlay", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "replay", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "load", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, Number]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "preload", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "seek", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "setLevel", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "closePayTipsCallback", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "createPlugin", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "setAdConfig", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "stop", null);
    __decorate([
        performanceCost,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "getBuiltInVideoReqInfoParam", null);
    return SuperPlayer;
}(H5Player));
var BUILD_TIME = envVals.BUILD_TIME;
var VERSION = envVals.VERSION;
bindExports(SuperPlayer);
// 为了让插件cdn能够搭配 @tencent/super-player npm 包使用，这里需要挂载异步插件所需要的全局变量
mountGlobal({
    globalName: 'SuperPlayer',
    target: SuperPlayer,
    onDuplicate: function () {
        console.warn('Possible duplicated SuperPlayer detected. Avoid to import this package multiple times.');
    },
});

export { BUILDIN_PLATFORM, BUILD_TIME, CTRL_EVENTS, CTRL_SIZE, CtrlbarPluginName, DEFAULT_SHOW_QUERY, ErrorPagePluginEvents, ErrorPagePluginName, HEVC_LV_VALUE, HOTPOINT_EVENTS, INFO_SVG_DOM_STR, InfoPanelEvents, InfoPanelPluginName, LAZY_PLUGINS, LOCAL_STORAGE_KEY, MaxRequestRetry, PLAY_CODEC, PLUGINS_URL, POSTER_IMAGE_ALT, POSTER_IMAGE_CLASS_NAME, PlayBtnStatus, PosterPluginName, RequestTimeout, SUPER_DATA_KEY, SUPER_END_STATE, SUPER_EVENTS, TipsPluginName, UIContextMenuPluginName, VERSION, WaterMarkCoverClassName, WatermarkError, WatermarkPluginName, adGlobalName, adScriptMaxLoadTime, adVersion, bodyOverflowClassName, classNameOnCtrlHide, classNameOnCtrlResize, containerClassName, contextMenuPluginName, ctrlbarPluginName, dataRoleMap, SuperPlayer as default, defaultErrorMsg, defaultErrorText, defaultLiveBusinessConfig, defaultShowTime, defaultSuperConfig, defaultVodBusinessConfig, defaultVodPlatform, defautVodSdtfrom, formatDefnName, getAdInitConfig, getBuiltInPlugins, getLocalDynamicConfig, getRootClassName, getSuperConfig, gradientClassName, hideClass, isInDomainWhiteList, largeSizeClassName, mergeDynamicConfig, mobileRootClassName, pcRootClassName, shadowClassName, skipAdDomainWhiteList };
